/**
 * Level Data Configuration
 * Multi-language support for word puzzle game
 * Each language has 100 predefined levels with target words and categories
 * 
 * GENERATED FILE - DO NOT EDIT MANUALLY
 * Generated from: scripts/output/all-levels-en-3alternatives-fixed.json
 *                 scripts/output/all-levels-da-3alternatives.json
 * 
 * To regenerate:
 * 1. Run: node scripts/runLevelGenerator.js generate-all en 1 100 --output scripts/output/all-levels-en-3alternatives-fixed.json
 * 2. Run: node scripts/runLevelGenerator.js generate-all da 1 100 --output scripts/output/all-levels-da-3alternatives.json
 * 3. Run: node scripts/convertToLevelData.js
 */

/**
 * Level data for English (EN)
 * 99 levels total
 */
const levelDataEN = [
  {
    "levelNumber": 1,
    "category": "Building",
    "correctAnswer": "PAVILION",
    "alternativeWords": [
      "ARENA",
      "PALACE",
      "CASTLE"
    ],
    "letterPool": [
      "P",
      "A",
      "A",
      "A",
      "V",
      "I",
      "I",
      "I",
      "L",
      "O",
      "N",
      "R",
      "R",
      "E",
      "E",
      "C",
      "S",
      "T"
    ],
    "poolString": "PAAAVIIILONRREECST"
  },
  {
    "levelNumber": 2,
    "category": "Vegetable",
    "correctAnswer": "BROCCOLI",
    "alternativeWords": [
      "PEA",
      "LEEK",
      "KALE"
    ],
    "letterPool": [
      "B",
      "R",
      "R",
      "O",
      "O",
      "O",
      "C",
      "C",
      "L",
      "I",
      "I",
      "P",
      "E",
      "E",
      "E",
      "A",
      "A",
      "K"
    ],
    "poolString": "BRROOOCCLIIPEEEAAK"
  },
  {
    "levelNumber": 3,
    "category": "Emotion",
    "correctAnswer": "GRATITUDE",
    "alternativeWords": [
      "LOVE",
      "LUST",
      "HATE"
    ],
    "letterPool": [
      "G",
      "R",
      "R",
      "A",
      "A",
      "T",
      "T",
      "I",
      "I",
      "U",
      "D",
      "E",
      "E",
      "L",
      "O",
      "V",
      "S",
      "H"
    ],
    "poolString": "GRRAATTIIUDEELOVSH"
  },
  {
    "levelNumber": 4,
    "category": "Element",
    "correctAnswer": "COPPER",
    "alternativeWords": [
      "HELIUM",
      "CARBON",
      "SODIUM"
    ],
    "letterPool": [
      "C",
      "O",
      "P",
      "P",
      "E",
      "E",
      "R",
      "H",
      "L",
      "I",
      "U",
      "M",
      "A",
      "A",
      "B",
      "N",
      "S",
      "D"
    ],
    "poolString": "COPPEERHLIUMAABNSD"
  },
  {
    "levelNumber": 5,
    "category": "Planet",
    "correctAnswer": "JUPITER",
    "alternativeWords": [
      "MARS",
      "VENUS",
      "EARTH"
    ],
    "letterPool": [
      "J",
      "U",
      "P",
      "I",
      "I",
      "T",
      "E",
      "E",
      "R",
      "R",
      "M",
      "A",
      "A",
      "S",
      "V",
      "N",
      "H",
      "O"
    ],
    "poolString": "JUPIITEERRMAASVNHO"
  },
  {
    "levelNumber": 6,
    "category": "Country",
    "correctAnswer": "THAILAND",
    "alternativeWords": [
      "INDIA",
      "CHINA",
      "JAPAN"
    ],
    "letterPool": [
      "T",
      "T",
      "H",
      "A",
      "A",
      "A",
      "I",
      "I",
      "I",
      "L",
      "N",
      "D",
      "C",
      "J",
      "P",
      "E",
      "R",
      "O"
    ],
    "poolString": "TTHAAAIIILNDCJPERO"
  },
  {
    "levelNumber": 7,
    "category": "Mammal",
    "correctAnswer": "BEAVER",
    "alternativeWords": [
      "BISON",
      "ZEBRA",
      "HORSE"
    ],
    "letterPool": [
      "B",
      "E",
      "E",
      "E",
      "A",
      "A",
      "V",
      "R",
      "R",
      "I",
      "I",
      "S",
      "O",
      "O",
      "N",
      "Z",
      "H",
      "T"
    ],
    "poolString": "BEEEAAVRRIISOONZHT"
  },
  {
    "levelNumber": 8,
    "category": "Sport",
    "correctAnswer": "BADMINTON",
    "alternativeWords": [
      "KARATE",
      "DIVING",
      "ROWING"
    ],
    "letterPool": [
      "B",
      "A",
      "A",
      "D",
      "M",
      "I",
      "I",
      "N",
      "N",
      "T",
      "O",
      "K",
      "R",
      "E",
      "E",
      "V",
      "G",
      "W"
    ],
    "poolString": "BAADMIINNTOKREEVGW"
  },
  {
    "levelNumber": 9,
    "category": "Country",
    "correctAnswer": "ARGENTINA",
    "alternativeWords": [
      "CHILE",
      "ITALY",
      "SPAIN"
    ],
    "letterPool": [
      "A",
      "A",
      "A",
      "R",
      "R",
      "G",
      "E",
      "E",
      "N",
      "N",
      "T",
      "I",
      "C",
      "H",
      "L",
      "Y",
      "S",
      "P"
    ],
    "poolString": "AAARRGEENNTICHLYSP"
  },
  {
    "levelNumber": 10,
    "category": "Fish",
    "correctAnswer": "SALMON",
    "alternativeWords": [
      "COD",
      "RAY",
      "EEL"
    ],
    "letterPool": [
      "S",
      "A",
      "A",
      "L",
      "M",
      "O",
      "O",
      "N",
      "C",
      "D",
      "R",
      "R",
      "Y",
      "E",
      "E",
      "E",
      "I",
      "T"
    ],
    "poolString": "SAALMOONCDRRYEEEIT"
  },
  {
    "levelNumber": 11,
    "category": "Body Part",
    "correctAnswer": "KIDNEY",
    "alternativeWords": [
      "HEAD",
      "FACE",
      "NOSE"
    ],
    "letterPool": [
      "K",
      "I",
      "I",
      "D",
      "N",
      "E",
      "E",
      "Y",
      "H",
      "A",
      "A",
      "F",
      "C",
      "O",
      "O",
      "S",
      "R",
      "T"
    ],
    "poolString": "KIIDNEEYHAAFCOOSRT"
  },
  {
    "levelNumber": 12,
    "category": "Planet",
    "correctAnswer": "NEPTUNE",
    "alternativeWords": [
      "PLUTO",
      "SATURN",
      "URANUS"
    ],
    "letterPool": [
      "N",
      "N",
      "E",
      "E",
      "E",
      "P",
      "T",
      "U",
      "U",
      "L",
      "O",
      "O",
      "S",
      "A",
      "A",
      "R",
      "R",
      "I"
    ],
    "poolString": "NNEEEPTUULOOSAARRI"
  },
  {
    "levelNumber": 13,
    "category": "Bird",
    "correctAnswer": "PEACOCK",
    "alternativeWords": [
      "CROW",
      "DOVE",
      "DUCK"
    ],
    "letterPool": [
      "P",
      "E",
      "E",
      "A",
      "A",
      "C",
      "C",
      "O",
      "O",
      "K",
      "R",
      "R",
      "W",
      "D",
      "V",
      "U",
      "I",
      "T"
    ],
    "poolString": "PEEAACCOOKRRWDVUIT"
  },
  {
    "levelNumber": 14,
    "category": "Tree",
    "correctAnswer": "WILLOW",
    "alternativeWords": [
      "BIRCH",
      "BEECH",
      "CEDAR"
    ],
    "letterPool": [
      "W",
      "W",
      "I",
      "I",
      "L",
      "L",
      "O",
      "B",
      "R",
      "R",
      "C",
      "H",
      "E",
      "E",
      "E",
      "D",
      "A",
      "A"
    ],
    "poolString": "WWIILLOBRRCHEEEDAA"
  },
  {
    "levelNumber": 15,
    "category": "Body Part",
    "correctAnswer": "SHOULDER",
    "alternativeWords": [
      "EYE",
      "EAR",
      "LIP"
    ],
    "letterPool": [
      "S",
      "H",
      "O",
      "O",
      "U",
      "L",
      "D",
      "E",
      "E",
      "E",
      "R",
      "R",
      "Y",
      "A",
      "A",
      "I",
      "I",
      "P"
    ],
    "poolString": "SHOOULDEEERRYAAIIP"
  },
  {
    "levelNumber": 16,
    "category": "Fish",
    "correctAnswer": "SWORDFISH",
    "alternativeWords": [
      "PERCH",
      "MARLIN",
      "HADDOCK"
    ],
    "letterPool": [
      "S",
      "S",
      "W",
      "O",
      "R",
      "D",
      "D",
      "F",
      "I",
      "H",
      "P",
      "E",
      "C",
      "M",
      "A",
      "L",
      "N",
      "K"
    ],
    "poolString": "SSWORDDFIHPECMALNK"
  },
  {
    "levelNumber": 17,
    "category": "Bird",
    "correctAnswer": "PELICAN",
    "alternativeWords": [
      "SWAN",
      "TERN",
      "EAGLE"
    ],
    "letterPool": [
      "P",
      "E",
      "E",
      "E",
      "L",
      "I",
      "I",
      "C",
      "A",
      "A",
      "N",
      "S",
      "W",
      "T",
      "R",
      "R",
      "G",
      "O"
    ],
    "poolString": "PEEELIICAANSWTRRGO"
  },
  {
    "levelNumber": 18,
    "category": "Flower",
    "correctAnswer": "LAVENDER",
    "alternativeWords": [
      "AZALEA",
      "PETUNIA",
      "JASMINE"
    ],
    "letterPool": [
      "L",
      "A",
      "A",
      "A",
      "V",
      "E",
      "E",
      "N",
      "D",
      "R",
      "Z",
      "P",
      "T",
      "U",
      "I",
      "J",
      "S",
      "M"
    ],
    "poolString": "LAAAVEENDRZPTUIJSM"
  },
  {
    "levelNumber": 19,
    "category": "Country",
    "correctAnswer": "NORWAY",
    "alternativeWords": [
      "UK",
      "USA",
      "PERU"
    ],
    "letterPool": [
      "N",
      "N",
      "O",
      "O",
      "R",
      "R",
      "W",
      "A",
      "A",
      "Y",
      "U",
      "K",
      "S",
      "P",
      "E",
      "E",
      "I",
      "T"
    ],
    "poolString": "NNOORRWAAYUKSPEEIT"
  },
  {
    "levelNumber": 20,
    "category": "Element",
    "correctAnswer": "NITROGEN",
    "alternativeWords": [
      "ZINC",
      "LEAD",
      "ARGON"
    ],
    "letterPool": [
      "N",
      "N",
      "I",
      "I",
      "T",
      "R",
      "R",
      "O",
      "O",
      "G",
      "E",
      "E",
      "Z",
      "C",
      "L",
      "A",
      "A",
      "D"
    ],
    "poolString": "NNIITRROOGEEZCLAAD"
  },
  {
    "levelNumber": 21,
    "category": "Vehicle",
    "correctAnswer": "TRUCK",
    "alternativeWords": [
      "RAFT",
      "TANK",
      "TRAIN"
    ],
    "letterPool": [
      "T",
      "T",
      "R",
      "R",
      "U",
      "C",
      "K",
      "A",
      "A",
      "F",
      "N",
      "N",
      "I",
      "I",
      "E",
      "O",
      "S",
      "L"
    ],
    "poolString": "TTRRUCKAAFNNIIEOSL"
  },
  {
    "levelNumber": 22,
    "category": "Gemstone",
    "correctAnswer": "SAPPHIRE",
    "alternativeWords": [
      "RUBY",
      "OPAL",
      "ONYX"
    ],
    "letterPool": [
      "S",
      "A",
      "A",
      "P",
      "P",
      "H",
      "I",
      "R",
      "R",
      "E",
      "E",
      "U",
      "B",
      "Y",
      "O",
      "L",
      "N",
      "X"
    ],
    "poolString": "SAAPPHIRREEUBYOLNX"
  },
  {
    "levelNumber": 23,
    "category": "Planet",
    "correctAnswer": "EUROPA",
    "alternativeWords": [
      "CERES",
      "TRITON",
      "CHARON"
    ],
    "letterPool": [
      "E",
      "E",
      "E",
      "U",
      "R",
      "R",
      "O",
      "P",
      "A",
      "A",
      "C",
      "S",
      "T",
      "T",
      "I",
      "I",
      "N",
      "H"
    ],
    "poolString": "EEEURROPAACSTTIINH"
  },
  {
    "levelNumber": 24,
    "category": "Clothing",
    "correctAnswer": "SWEATER",
    "alternativeWords": [
      "SUIT",
      "BELT",
      "SHIRT"
    ],
    "letterPool": [
      "S",
      "W",
      "E",
      "E",
      "E",
      "A",
      "A",
      "T",
      "T",
      "R",
      "R",
      "U",
      "I",
      "I",
      "B",
      "L",
      "H",
      "O"
    ],
    "poolString": "SWEEEAATTRRUIIBLHO"
  },
  {
    "levelNumber": 25,
    "category": "Body Part",
    "correctAnswer": "ELBOW",
    "alternativeWords": [
      "JAW",
      "ARM",
      "RIB"
    ],
    "letterPool": [
      "E",
      "E",
      "L",
      "B",
      "O",
      "O",
      "W",
      "J",
      "A",
      "A",
      "R",
      "R",
      "M",
      "I",
      "I",
      "T",
      "N",
      "S"
    ],
    "poolString": "EELBOOWJAARRMIITNS"
  },
  {
    "levelNumber": 26,
    "category": "Emotion",
    "correctAnswer": "JEALOUSY",
    "alternativeWords": [
      "RAGE",
      "FURY",
      "FEAR"
    ],
    "letterPool": [
      "J",
      "E",
      "E",
      "A",
      "A",
      "L",
      "O",
      "O",
      "U",
      "S",
      "Y",
      "R",
      "R",
      "G",
      "F",
      "I",
      "T",
      "N"
    ],
    "poolString": "JEEAALOOUSYRRGFITN"
  },
  {
    "levelNumber": 27,
    "category": "Building",
    "correctAnswer": "HOUSE",
    "alternativeWords": [
      "MILL",
      "SHOP",
      "MALL"
    ],
    "letterPool": [
      "H",
      "O",
      "O",
      "U",
      "S",
      "E",
      "E",
      "M",
      "I",
      "I",
      "L",
      "L",
      "P",
      "A",
      "A",
      "R",
      "T",
      "N"
    ],
    "poolString": "HOOUSEEMIILLPAARTN"
  },
  {
    "levelNumber": 28,
    "category": "Fruit",
    "correctAnswer": "APPLE",
    "alternativeWords": [
      "PEACH",
      "GRAPE",
      "BERRY"
    ],
    "letterPool": [
      "A",
      "A",
      "P",
      "P",
      "L",
      "E",
      "E",
      "C",
      "H",
      "G",
      "R",
      "R",
      "R",
      "B",
      "Y",
      "I",
      "O",
      "T"
    ],
    "poolString": "AAPPLEECHGRRRBYIOT"
  },
  {
    "levelNumber": 29,
    "category": "Gemstone",
    "correctAnswer": "GARNET",
    "alternativeWords": [
      "BERYL",
      "JASPER",
      "QUARTZ"
    ],
    "letterPool": [
      "G",
      "A",
      "A",
      "R",
      "R",
      "N",
      "E",
      "E",
      "T",
      "B",
      "Y",
      "L",
      "J",
      "S",
      "P",
      "Q",
      "U",
      "Z"
    ],
    "poolString": "GAARRNEETBYLJSPQUZ"
  },
  {
    "levelNumber": 30,
    "category": "Flower",
    "correctAnswer": "DAFFODIL",
    "alternativeWords": [
      "TULIP",
      "DAISY",
      "PANSY"
    ],
    "letterPool": [
      "D",
      "D",
      "A",
      "A",
      "F",
      "F",
      "O",
      "I",
      "I",
      "L",
      "T",
      "U",
      "P",
      "S",
      "Y",
      "N",
      "E",
      "R"
    ],
    "poolString": "DDAAFFOIILTUPSYNER"
  },
  {
    "levelNumber": 31,
    "category": "Musical Instrument",
    "correctAnswer": "ACCORDION",
    "alternativeWords": [
      "TUBA",
      "HORN",
      "DRUM"
    ],
    "letterPool": [
      "A",
      "A",
      "C",
      "C",
      "O",
      "O",
      "R",
      "R",
      "D",
      "I",
      "I",
      "N",
      "T",
      "U",
      "B",
      "H",
      "M",
      "E"
    ],
    "poolString": "AACCOORRDIINTUBHME"
  },
  {
    "levelNumber": 32,
    "category": "Sport",
    "correctAnswer": "GYMNASTICS",
    "alternativeWords": [
      "RUGBY",
      "SOCCER",
      "HOCKEY"
    ],
    "letterPool": [
      "G",
      "Y",
      "M",
      "N",
      "A",
      "S",
      "S",
      "T",
      "I",
      "C",
      "C",
      "R",
      "U",
      "B",
      "O",
      "E",
      "H",
      "K"
    ],
    "poolString": "GYMNASSTICCRUBOEHK"
  },
  {
    "levelNumber": 33,
    "category": "Musical Instrument",
    "correctAnswer": "SAXOPHONE",
    "alternativeWords": [
      "HARP",
      "LYRE",
      "OBOE"
    ],
    "letterPool": [
      "S",
      "A",
      "A",
      "X",
      "O",
      "O",
      "O",
      "P",
      "H",
      "N",
      "E",
      "E",
      "R",
      "R",
      "L",
      "Y",
      "B",
      "I"
    ],
    "poolString": "SAAXOOOPHNEERRLYBI"
  },
  {
    "levelNumber": 34,
    "category": "Mammal",
    "correctAnswer": "WALRUS",
    "alternativeWords": [
      "CAMEL",
      "LLAMA",
      "DONKEY"
    ],
    "letterPool": [
      "W",
      "A",
      "A",
      "A",
      "L",
      "L",
      "R",
      "U",
      "S",
      "C",
      "M",
      "E",
      "E",
      "D",
      "O",
      "N",
      "K",
      "Y"
    ],
    "poolString": "WAAALLRUSCMEEDONKY"
  },
  {
    "levelNumber": 35,
    "category": "Planet",
    "correctAnswer": "MERCURY",
    "alternativeWords": [
      "IO",
      "ERIS",
      "TITAN"
    ],
    "letterPool": [
      "M",
      "E",
      "E",
      "R",
      "R",
      "R",
      "C",
      "U",
      "Y",
      "I",
      "I",
      "O",
      "S",
      "T",
      "T",
      "A",
      "A",
      "N"
    ],
    "poolString": "MEERRRCUYIIOSTTAAN"
  },
  {
    "levelNumber": 36,
    "category": "Mammal",
    "correctAnswer": "GIRAFFE",
    "alternativeWords": [
      "OTTER",
      "RHINO",
      "HIPPO"
    ],
    "letterPool": [
      "G",
      "I",
      "I",
      "R",
      "R",
      "A",
      "A",
      "F",
      "F",
      "E",
      "E",
      "O",
      "T",
      "T",
      "H",
      "N",
      "P",
      "P"
    ],
    "poolString": "GIIRRAAFFEEOTTHNPP"
  },
  {
    "levelNumber": 37,
    "category": "City",
    "correctAnswer": "BARCELONA",
    "alternativeWords": [
      "ROME",
      "OSLO",
      "PARIS"
    ],
    "letterPool": [
      "B",
      "A",
      "A",
      "A",
      "R",
      "R",
      "C",
      "E",
      "E",
      "L",
      "O",
      "O",
      "N",
      "M",
      "S",
      "P",
      "I",
      "I"
    ],
    "poolString": "BAAARRCEELOONMSPII"
  },
  {
    "levelNumber": 38,
    "category": "Kitchen Appliance",
    "correctAnswer": "BLENDER",
    "alternativeWords": [
      "FAN",
      "OVEN",
      "HOOD"
    ],
    "letterPool": [
      "B",
      "L",
      "E",
      "E",
      "E",
      "N",
      "D",
      "R",
      "R",
      "F",
      "A",
      "A",
      "O",
      "O",
      "O",
      "V",
      "H",
      "I"
    ],
    "poolString": "BLEEENDRRFAAOOOVHI"
  },
  {
    "levelNumber": 39,
    "category": "Animal",
    "correctAnswer": "ELEPHANT",
    "alternativeWords": [
      "CAT",
      "DOG",
      "FOX"
    ],
    "letterPool": [
      "E",
      "E",
      "E",
      "L",
      "P",
      "H",
      "A",
      "A",
      "N",
      "T",
      "C",
      "D",
      "O",
      "G",
      "F",
      "X",
      "R",
      "I"
    ],
    "poolString": "EEELPHAANTCDOGFXRI"
  },
  {
    "levelNumber": 40,
    "category": "Weather Phenomenon",
    "correctAnswer": "BLIZZARD",
    "alternativeWords": [
      "RAIN",
      "SNOW",
      "HAIL"
    ],
    "letterPool": [
      "B",
      "L",
      "I",
      "I",
      "Z",
      "Z",
      "A",
      "A",
      "R",
      "R",
      "D",
      "N",
      "S",
      "O",
      "O",
      "W",
      "H",
      "E"
    ],
    "poolString": "BLIIZZAARRDNSOOWHE"
  },
  {
    "levelNumber": 41,
    "category": "Flower",
    "correctAnswer": "HIBISCUS",
    "alternativeWords": [
      "ASTER",
      "POPPY",
      "PEONY"
    ],
    "letterPool": [
      "H",
      "I",
      "I",
      "B",
      "S",
      "S",
      "C",
      "U",
      "A",
      "T",
      "E",
      "R",
      "P",
      "P",
      "P",
      "O",
      "Y",
      "N"
    ],
    "poolString": "HIIBSSCUATERPPPOYN"
  },
  {
    "levelNumber": 42,
    "category": "City",
    "correctAnswer": "MELBOURNE",
    "alternativeWords": [
      "LONDON",
      "MADRID",
      "BERLIN"
    ],
    "letterPool": [
      "M",
      "E",
      "E",
      "E",
      "L",
      "B",
      "O",
      "O",
      "U",
      "R",
      "R",
      "N",
      "N",
      "D",
      "D",
      "A",
      "A",
      "I"
    ],
    "poolString": "MEEELBOOURRNNDDAAI"
  },
  {
    "levelNumber": 43,
    "category": "Vehicle",
    "correctAnswer": "SUBMARINE",
    "alternativeWords": [
      "JET",
      "TAXI",
      "TRAM"
    ],
    "letterPool": [
      "S",
      "U",
      "B",
      "M",
      "A",
      "A",
      "R",
      "R",
      "I",
      "I",
      "N",
      "E",
      "E",
      "J",
      "T",
      "T",
      "X",
      "O"
    ],
    "poolString": "SUBMAARRIINEEJTTXO"
  },
  {
    "levelNumber": 44,
    "category": "Building",
    "correctAnswer": "CATHEDRAL",
    "alternativeWords": [
      "HOME",
      "BARN",
      "SHED"
    ],
    "letterPool": [
      "C",
      "A",
      "A",
      "A",
      "T",
      "H",
      "E",
      "E",
      "D",
      "R",
      "R",
      "L",
      "O",
      "M",
      "B",
      "N",
      "S",
      "I"
    ],
    "poolString": "CAAATHEEDRRLOMBNSI"
  },
  {
    "levelNumber": 45,
    "category": "Fish",
    "correctAnswer": "BARRACUDA",
    "alternativeWords": [
      "BASS",
      "PIKE",
      "CARP"
    ],
    "letterPool": [
      "B",
      "A",
      "A",
      "A",
      "R",
      "R",
      "R",
      "C",
      "U",
      "D",
      "S",
      "S",
      "P",
      "I",
      "I",
      "K",
      "E",
      "E"
    ],
    "poolString": "BAAARRRCUDSSPIIKEE"
  },
  {
    "levelNumber": 46,
    "category": "Profession",
    "correctAnswer": "ENGINEER",
    "alternativeWords": [
      "BAKER",
      "MINER",
      "PILOT"
    ],
    "letterPool": [
      "E",
      "E",
      "E",
      "N",
      "N",
      "G",
      "I",
      "R",
      "R",
      "B",
      "A",
      "A",
      "K",
      "M",
      "P",
      "L",
      "O",
      "T"
    ],
    "poolString": "EEENNGIRRBAAKMPLOT"
  },
  {
    "levelNumber": 47,
    "category": "Vegetable",
    "correctAnswer": "EGGPLANT",
    "alternativeWords": [
      "ONION",
      "CHARD",
      "CHILI"
    ],
    "letterPool": [
      "E",
      "E",
      "G",
      "G",
      "P",
      "L",
      "A",
      "N",
      "N",
      "T",
      "O",
      "O",
      "I",
      "I",
      "C",
      "H",
      "R",
      "D"
    ],
    "poolString": "EEGGPLANNTOOIICHRD"
  },
  {
    "levelNumber": 48,
    "category": "Element",
    "correctAnswer": "OXYGEN",
    "alternativeWords": [
      "TIN",
      "NEON",
      "IRON"
    ],
    "letterPool": [
      "O",
      "O",
      "X",
      "Y",
      "G",
      "E",
      "E",
      "N",
      "N",
      "N",
      "T",
      "T",
      "I",
      "I",
      "R",
      "R",
      "A",
      "S"
    ],
    "poolString": "OOXYGEENNNTTIIRRAS"
  },
  {
    "levelNumber": 49,
    "category": "Body Part",
    "correctAnswer": "ANKLE",
    "alternativeWords": [
      "HIP",
      "LEG",
      "TOE"
    ],
    "letterPool": [
      "A",
      "A",
      "N",
      "N",
      "K",
      "L",
      "E",
      "E",
      "H",
      "I",
      "I",
      "P",
      "G",
      "T",
      "T",
      "O",
      "O",
      "R"
    ],
    "poolString": "AANNKLEEHIIPGTTOOR"
  },
  {
    "levelNumber": 50,
    "category": "Clothing",
    "correctAnswer": "BLAZER",
    "alternativeWords": [
      "CAP",
      "TIE",
      "COAT"
    ],
    "letterPool": [
      "B",
      "L",
      "A",
      "A",
      "Z",
      "E",
      "E",
      "R",
      "R",
      "C",
      "P",
      "T",
      "T",
      "I",
      "I",
      "O",
      "O",
      "N"
    ],
    "poolString": "BLAAZEERRCPTTIIOON"
  },
  {
    "levelNumber": 51,
    "category": "Vegetable",
    "correctAnswer": "CARROT",
    "alternativeWords": [
      "BEAN",
      "CORN",
      "BEET"
    ],
    "letterPool": [
      "C",
      "A",
      "A",
      "R",
      "R",
      "R",
      "O",
      "O",
      "T",
      "T",
      "B",
      "E",
      "E",
      "E",
      "N",
      "N",
      "I",
      "S"
    ],
    "poolString": "CAARRROOTTBEEENNIS"
  },
  {
    "levelNumber": 52,
    "category": "Fruit",
    "correctAnswer": "PERSIMMON",
    "alternativeWords": [
      "MELON",
      "LEMON",
      "CHERRY"
    ],
    "letterPool": [
      "P",
      "E",
      "E",
      "R",
      "R",
      "R",
      "S",
      "I",
      "I",
      "M",
      "M",
      "O",
      "N",
      "L",
      "C",
      "H",
      "Y",
      "A"
    ],
    "poolString": "PEERRRSIIMMONLCHYA"
  },
  {
    "levelNumber": 53,
    "category": "Fish",
    "correctAnswer": "ANGELFISH",
    "alternativeWords": [
      "TUNA",
      "TROUT",
      "SHARK"
    ],
    "letterPool": [
      "A",
      "A",
      "N",
      "G",
      "E",
      "E",
      "L",
      "F",
      "I",
      "S",
      "H",
      "T",
      "T",
      "U",
      "R",
      "R",
      "O",
      "K"
    ],
    "poolString": "AANGEELFISHTTURROK"
  },
  {
    "levelNumber": 54,
    "category": "Vegetable",
    "correctAnswer": "ASPARAGUS",
    "alternativeWords": [
      "POTATO",
      "TOMATO",
      "GARLIC"
    ],
    "letterPool": [
      "A",
      "A",
      "A",
      "S",
      "S",
      "P",
      "R",
      "G",
      "U",
      "O",
      "O",
      "T",
      "T",
      "M",
      "L",
      "I",
      "C",
      "E"
    ],
    "poolString": "AAASSPRGUOOTTMLICE"
  },
  {
    "levelNumber": 55,
    "category": "Animal",
    "correctAnswer": "PLATYPUS",
    "alternativeWords": [
      "HARE",
      "TIGER",
      "MOOSE"
    ],
    "letterPool": [
      "P",
      "P",
      "L",
      "A",
      "A",
      "T",
      "Y",
      "U",
      "S",
      "H",
      "R",
      "E",
      "E",
      "I",
      "G",
      "M",
      "O",
      "O"
    ],
    "poolString": "PPLAATYUSHREEIGMOO"
  },
  {
    "levelNumber": 56,
    "category": "City",
    "correctAnswer": "ISTANBUL",
    "alternativeWords": [
      "TOKYO",
      "SEOUL",
      "MIAMI"
    ],
    "letterPool": [
      "I",
      "I",
      "S",
      "T",
      "A",
      "A",
      "N",
      "B",
      "U",
      "L",
      "O",
      "O",
      "K",
      "Y",
      "E",
      "E",
      "M",
      "M"
    ],
    "poolString": "IISTAANBULOOKYEEMM"
  },
  {
    "levelNumber": 57,
    "category": "Emotion",
    "correctAnswer": "ANXIETY",
    "alternativeWords": [
      "ENVY",
      "HOPE",
      "BLISS"
    ],
    "letterPool": [
      "A",
      "A",
      "N",
      "X",
      "I",
      "E",
      "E",
      "T",
      "Y",
      "V",
      "H",
      "O",
      "P",
      "B",
      "L",
      "S",
      "S",
      "R"
    ],
    "poolString": "AANXIEETYVHOPBLSSR"
  },
  {
    "levelNumber": 58,
    "category": "Color",
    "correctAnswer": "EMERALD",
    "alternativeWords": [
      "CYAN",
      "JADE",
      "MINT"
    ],
    "letterPool": [
      "E",
      "E",
      "E",
      "M",
      "R",
      "R",
      "A",
      "A",
      "L",
      "D",
      "C",
      "Y",
      "N",
      "J",
      "I",
      "I",
      "T",
      "O"
    ],
    "poolString": "EEEMRRAALDCYNJIITO"
  },
  {
    "levelNumber": 59,
    "category": "Profession",
    "correctAnswer": "ARCHITECT",
    "alternativeWords": [
      "POET",
      "CHEF",
      "COOK"
    ],
    "letterPool": [
      "A",
      "A",
      "R",
      "R",
      "C",
      "C",
      "H",
      "I",
      "I",
      "T",
      "T",
      "E",
      "E",
      "P",
      "O",
      "O",
      "F",
      "K"
    ],
    "poolString": "AARRCCHIITTEEPOOFK"
  },
  {
    "levelNumber": 60,
    "category": "Furniture",
    "correctAnswer": "OTTOMAN",
    "alternativeWords": [
      "SEAT",
      "SOFA",
      "DESK"
    ],
    "letterPool": [
      "O",
      "O",
      "O",
      "T",
      "T",
      "T",
      "M",
      "A",
      "A",
      "N",
      "S",
      "E",
      "E",
      "F",
      "D",
      "K",
      "R",
      "I"
    ],
    "poolString": "OOOTTTMAANSEEFDKRI"
  },
  {
    "levelNumber": 61,
    "category": "Gemstone",
    "correctAnswer": "DIAMOND",
    "alternativeWords": [
      "PEARL",
      "TOPAZ",
      "AGATE"
    ],
    "letterPool": [
      "D",
      "D",
      "I",
      "A",
      "A",
      "A",
      "M",
      "O",
      "N",
      "P",
      "E",
      "E",
      "R",
      "R",
      "L",
      "T",
      "Z",
      "G"
    ],
    "poolString": "DDIAAAMONPEERRLTZG"
  },
  {
    "levelNumber": 62,
    "category": "Fruit",
    "correctAnswer": "MANGO",
    "alternativeWords": [
      "FIG",
      "PEAR",
      "PLUM"
    ],
    "letterPool": [
      "M",
      "A",
      "A",
      "N",
      "G",
      "O",
      "O",
      "F",
      "I",
      "I",
      "P",
      "E",
      "E",
      "R",
      "R",
      "L",
      "U",
      "T"
    ],
    "poolString": "MAANGOOFIIPEERRLUT"
  },
  {
    "levelNumber": 63,
    "category": "Bird",
    "correctAnswer": "FALCON",
    "alternativeWords": [
      "RAVEN",
      "ROBIN",
      "FINCH"
    ],
    "letterPool": [
      "F",
      "A",
      "A",
      "L",
      "C",
      "O",
      "O",
      "N",
      "R",
      "R",
      "V",
      "E",
      "E",
      "B",
      "I",
      "I",
      "H",
      "T"
    ],
    "poolString": "FAALCOONRRVEEBIIHT"
  },
  {
    "levelNumber": 64,
    "category": "Sport",
    "correctAnswer": "WRESTLING",
    "alternativeWords": [
      "TENNIS",
      "SQUASH",
      "BOXING"
    ],
    "letterPool": [
      "W",
      "R",
      "E",
      "S",
      "S",
      "T",
      "L",
      "I",
      "N",
      "N",
      "G",
      "Q",
      "U",
      "A",
      "H",
      "B",
      "O",
      "X"
    ],
    "poolString": "WRESSTLINNGQUAHBOX"
  },
  {
    "levelNumber": 65,
    "category": "Furniture",
    "correctAnswer": "BOOKSHELF",
    "alternativeWords": [
      "LAMP",
      "CHAIR",
      "STOOL"
    ],
    "letterPool": [
      "B",
      "O",
      "O",
      "K",
      "S",
      "H",
      "E",
      "E",
      "L",
      "F",
      "A",
      "A",
      "M",
      "P",
      "C",
      "I",
      "R",
      "T"
    ],
    "poolString": "BOOKSHEELFAAMPCIRT"
  },
  {
    "levelNumber": 66,
    "category": "Profession",
    "correctAnswer": "PHARMACIST",
    "alternativeWords": [
      "NURSE",
      "TUTOR",
      "COACH"
    ],
    "letterPool": [
      "P",
      "H",
      "A",
      "A",
      "A",
      "R",
      "M",
      "C",
      "C",
      "I",
      "S",
      "T",
      "T",
      "N",
      "U",
      "E",
      "E",
      "O"
    ],
    "poolString": "PHAAARMCCISTTNUEEO"
  },
  {
    "levelNumber": 67,
    "category": "Clothing",
    "correctAnswer": "TROUSERS",
    "alternativeWords": [
      "VEST",
      "GOWN",
      "ROBE"
    ],
    "letterPool": [
      "T",
      "R",
      "R",
      "R",
      "O",
      "O",
      "U",
      "S",
      "S",
      "E",
      "E",
      "V",
      "G",
      "W",
      "N",
      "B",
      "A",
      "I"
    ],
    "poolString": "TRRROOUSSEEVGWNBAI"
  },
  {
    "levelNumber": 68,
    "category": "Emotion",
    "correctAnswer": "EXCITEMENT",
    "alternativeWords": [
      "JOY",
      "IRE",
      "AWE"
    ],
    "letterPool": [
      "E",
      "E",
      "E",
      "X",
      "C",
      "I",
      "T",
      "T",
      "M",
      "N",
      "J",
      "O",
      "Y",
      "R",
      "R",
      "A",
      "A",
      "W"
    ],
    "poolString": "EEEXCITTMNJOYRRAAW"
  },
  {
    "levelNumber": 69,
    "category": "Country",
    "correctAnswer": "MOROCCO",
    "alternativeWords": [
      "EGYPT",
      "KENYA",
      "GHANA"
    ],
    "letterPool": [
      "M",
      "O",
      "O",
      "O",
      "R",
      "C",
      "C",
      "E",
      "E",
      "G",
      "Y",
      "P",
      "T",
      "K",
      "N",
      "A",
      "A",
      "H"
    ],
    "poolString": "MOOORCCEEGYPTKNAAH"
  },
  {
    "levelNumber": 70,
    "category": "Musical Instrument",
    "correctAnswer": "CLARINET",
    "alternativeWords": [
      "GONG",
      "BELL",
      "PIANO"
    ],
    "letterPool": [
      "C",
      "L",
      "L",
      "A",
      "A",
      "R",
      "R",
      "I",
      "I",
      "N",
      "E",
      "E",
      "T",
      "G",
      "G",
      "O",
      "B",
      "P"
    ],
    "poolString": "CLLAARRIINEETGGOBP"
  },
  {
    "levelNumber": 71,
    "category": "Weather Phenomenon",
    "correctAnswer": "MONSOON",
    "alternativeWords": [
      "GUST",
      "SLEET",
      "FROST"
    ],
    "letterPool": [
      "M",
      "O",
      "O",
      "O",
      "N",
      "N",
      "S",
      "G",
      "U",
      "T",
      "L",
      "E",
      "E",
      "E",
      "F",
      "R",
      "R",
      "A"
    ],
    "poolString": "MOOONNSGUTLEEEFRRA"
  },
  {
    "levelNumber": 72,
    "category": "Kitchen Appliance",
    "correctAnswer": "MICROWAVE",
    "alternativeWords": [
      "JUICER",
      "WAFFLE",
      "FRIDGE"
    ],
    "letterPool": [
      "M",
      "I",
      "C",
      "R",
      "O",
      "W",
      "A",
      "A",
      "V",
      "E",
      "E",
      "J",
      "U",
      "F",
      "F",
      "L",
      "D",
      "G"
    ],
    "poolString": "MICROWAAVEEJUFFLDG"
  },
  {
    "levelNumber": 73,
    "category": "Bird",
    "correctAnswer": "FLAMINGO",
    "alternativeWords": [
      "OWL",
      "EMU",
      "HAWK"
    ],
    "letterPool": [
      "F",
      "L",
      "A",
      "A",
      "M",
      "I",
      "I",
      "N",
      "G",
      "O",
      "O",
      "W",
      "E",
      "E",
      "U",
      "H",
      "K",
      "R"
    ],
    "poolString": "FLAAMIINGOOWEEUHKR"
  },
  {
    "levelNumber": 74,
    "category": "Clothing",
    "correctAnswer": "CARDIGAN",
    "alternativeWords": [
      "TOP",
      "TEE",
      "HAT"
    ],
    "letterPool": [
      "C",
      "A",
      "A",
      "A",
      "R",
      "R",
      "D",
      "I",
      "I",
      "G",
      "N",
      "T",
      "O",
      "P",
      "E",
      "E",
      "E",
      "H"
    ],
    "poolString": "CAAARRDIIGNTOPEEEH"
  },
  {
    "levelNumber": 75,
    "category": "Flower",
    "correctAnswer": "ORCHID",
    "alternativeWords": [
      "ROSE",
      "LILY",
      "IRIS"
    ],
    "letterPool": [
      "O",
      "O",
      "R",
      "R",
      "C",
      "H",
      "I",
      "I",
      "I",
      "D",
      "S",
      "E",
      "E",
      "L",
      "L",
      "Y",
      "A",
      "T"
    ],
    "poolString": "OORRCHIIIDSEELLYAT"
  },
  {
    "levelNumber": 76,
    "category": "Vehicle",
    "correctAnswer": "SCOOTER",
    "alternativeWords": [
      "BIKE",
      "BOAT",
      "SHIP"
    ],
    "letterPool": [
      "S",
      "C",
      "O",
      "O",
      "O",
      "T",
      "E",
      "E",
      "R",
      "R",
      "B",
      "I",
      "I",
      "K",
      "A",
      "A",
      "H",
      "P"
    ],
    "poolString": "SCOOOTEERRBIIKAAHP"
  },
  {
    "levelNumber": 77,
    "category": "Color",
    "correctAnswer": "VIOLET",
    "alternativeWords": [
      "GOLD",
      "NAVY",
      "TEAL"
    ],
    "letterPool": [
      "V",
      "I",
      "I",
      "O",
      "O",
      "L",
      "E",
      "E",
      "T",
      "T",
      "G",
      "D",
      "N",
      "N",
      "A",
      "A",
      "Y",
      "R"
    ],
    "poolString": "VIIOOLEETTGDNNAAYR"
  },
  {
    "levelNumber": 78,
    "category": "Musical Instrument",
    "correctAnswer": "XYLOPHONE",
    "alternativeWords": [
      "ORGAN",
      "BANJO",
      "VIOLA"
    ],
    "letterPool": [
      "X",
      "Y",
      "L",
      "O",
      "O",
      "P",
      "H",
      "N",
      "E",
      "E",
      "R",
      "G",
      "A",
      "A",
      "B",
      "J",
      "V",
      "I"
    ],
    "poolString": "XYLOOPHNEERGAABJVI"
  },
  {
    "levelNumber": 79,
    "category": "Sport",
    "correctAnswer": "BASKETBALL",
    "alternativeWords": [
      "GOLF",
      "JUDO",
      "LUGE"
    ],
    "letterPool": [
      "B",
      "B",
      "A",
      "A",
      "A",
      "S",
      "K",
      "E",
      "E",
      "T",
      "L",
      "L",
      "G",
      "O",
      "F",
      "J",
      "U",
      "D"
    ],
    "poolString": "BBAAASKEETLLGOFJUD"
  },
  {
    "levelNumber": 80,
    "category": "Weather Phenomenon",
    "correctAnswer": "HURRICANE",
    "alternativeWords": [
      "FOG",
      "DEW",
      "ICE"
    ],
    "letterPool": [
      "H",
      "U",
      "R",
      "R",
      "R",
      "I",
      "I",
      "C",
      "A",
      "A",
      "N",
      "E",
      "E",
      "F",
      "O",
      "G",
      "D",
      "W"
    ],
    "poolString": "HURRRIICAANEEFOGDW"
  },
  {
    "levelNumber": 81,
    "category": "Tree",
    "correctAnswer": "MAPLE",
    "alternativeWords": [
      "OAK",
      "ELM",
      "ASH"
    ],
    "letterPool": [
      "M",
      "A",
      "A",
      "P",
      "L",
      "L",
      "E",
      "E",
      "O",
      "O",
      "K",
      "S",
      "S",
      "H",
      "R",
      "I",
      "T",
      "N"
    ],
    "poolString": "MAAPLLEEOOKSSHRITN"
  },
  {
    "levelNumber": 82,
    "category": "Mammal",
    "correctAnswer": "DOLPHIN",
    "alternativeWords": [
      "ELK",
      "MULE",
      "WHALE"
    ],
    "letterPool": [
      "D",
      "O",
      "O",
      "L",
      "P",
      "H",
      "I",
      "I",
      "N",
      "E",
      "E",
      "K",
      "M",
      "U",
      "W",
      "A",
      "A",
      "R"
    ],
    "poolString": "DOOLPHIINEEKMUWAAR"
  },
  {
    "levelNumber": 83,
    "category": "Element",
    "correctAnswer": "TITANIUM",
    "alternativeWords": [
      "SULFUR",
      "SILVER",
      "NICKEL"
    ],
    "letterPool": [
      "T",
      "T",
      "I",
      "I",
      "A",
      "N",
      "U",
      "U",
      "M",
      "S",
      "L",
      "F",
      "R",
      "V",
      "E",
      "E",
      "C",
      "K"
    ],
    "poolString": "TTIIANUUMSLFRVEECK"
  },
  {
    "levelNumber": 84,
    "category": "Color",
    "correctAnswer": "TURQUOISE",
    "alternativeWords": [
      "RED",
      "TAN",
      "BLUE"
    ],
    "letterPool": [
      "T",
      "U",
      "U",
      "R",
      "R",
      "Q",
      "O",
      "I",
      "I",
      "S",
      "E",
      "E",
      "D",
      "A",
      "A",
      "N",
      "B",
      "L"
    ],
    "poolString": "TUURRQOIISEEDAANBL"
  },
  {
    "levelNumber": 85,
    "category": "Furniture",
    "correctAnswer": "WARDROBE",
    "alternativeWords": [
      "BAR",
      "BED",
      "COT"
    ],
    "letterPool": [
      "W",
      "A",
      "A",
      "R",
      "R",
      "R",
      "D",
      "O",
      "O",
      "B",
      "E",
      "E",
      "C",
      "T",
      "T",
      "I",
      "N",
      "S"
    ],
    "poolString": "WAARRRDOOBEECTTINS"
  },
  {
    "levelNumber": 86,
    "category": "Kitchen Appliance",
    "correctAnswer": "TOASTER",
    "alternativeWords": [
      "STOVE",
      "RANGE",
      "MIXER"
    ],
    "letterPool": [
      "T",
      "T",
      "O",
      "O",
      "A",
      "A",
      "S",
      "E",
      "E",
      "R",
      "R",
      "V",
      "N",
      "G",
      "M",
      "I",
      "I",
      "X"
    ],
    "poolString": "TTOOAASEERRVNGMIIX"
  },
  {
    "levelNumber": 87,
    "category": "Profession",
    "correctAnswer": "JOURNALIST",
    "alternativeWords": [
      "JUDGE",
      "CLERK",
      "ACTOR"
    ],
    "letterPool": [
      "J",
      "O",
      "U",
      "R",
      "R",
      "N",
      "A",
      "A",
      "L",
      "I",
      "S",
      "T",
      "D",
      "G",
      "E",
      "E",
      "C",
      "K"
    ],
    "poolString": "JOURRNAALISTDGEECK"
  },
  {
    "levelNumber": 88,
    "category": "Vehicle",
    "correctAnswer": "GLIDER",
    "alternativeWords": [
      "CAR",
      "VAN",
      "BUS"
    ],
    "letterPool": [
      "G",
      "L",
      "I",
      "I",
      "D",
      "E",
      "E",
      "R",
      "R",
      "C",
      "A",
      "A",
      "V",
      "N",
      "B",
      "U",
      "S",
      "O"
    ],
    "poolString": "GLIIDEERRCAAVNBUSO"
  },
  {
    "levelNumber": 89,
    "category": "Tree",
    "correctAnswer": "SEQUOIA",
    "alternativeWords": [
      "FIR",
      "PINE",
      "PALM"
    ],
    "letterPool": [
      "S",
      "E",
      "E",
      "Q",
      "U",
      "O",
      "O",
      "I",
      "I",
      "A",
      "A",
      "F",
      "R",
      "R",
      "P",
      "N",
      "L",
      "M"
    ],
    "poolString": "SEEQUOOIIAAFRRPNLM"
  },
  {
    "levelNumber": 90,
    "category": "City",
    "correctAnswer": "SINGAPORE",
    "alternativeWords": [
      "CAIRO",
      "LAGOS",
      "DELHI"
    ],
    "letterPool": [
      "S",
      "I",
      "I",
      "N",
      "G",
      "A",
      "A",
      "P",
      "O",
      "O",
      "R",
      "R",
      "E",
      "E",
      "C",
      "L",
      "D",
      "H"
    ],
    "poolString": "SIINGAAPOORREECLDH"
  },
  {
    "levelNumber": 91,
    "category": "Tree",
    "correctAnswer": "MAGNOLIA",
    "alternativeWords": [
      "ASPEN",
      "ALDER",
      "SPRUCE"
    ],
    "letterPool": [
      "M",
      "A",
      "A",
      "A",
      "G",
      "N",
      "O",
      "L",
      "I",
      "S",
      "P",
      "E",
      "E",
      "D",
      "R",
      "R",
      "U",
      "C"
    ],
    "poolString": "MAAAGNOLISPEEDRRUC"
  },
  {
    "levelNumber": 92,
    "category": "Animal",
    "correctAnswer": "OCTOPUS",
    "alternativeWords": [
      "RAT",
      "LION",
      "BEAR"
    ],
    "letterPool": [
      "O",
      "O",
      "C",
      "T",
      "P",
      "U",
      "S",
      "R",
      "R",
      "A",
      "A",
      "L",
      "I",
      "I",
      "N",
      "B",
      "E",
      "E"
    ],
    "poolString": "OOCTPUSRRAALIINBEE"
  },
  {
    "levelNumber": 93,
    "category": "Furniture",
    "correctAnswer": "CABINET",
    "alternativeWords": [
      "BUNK",
      "CRIB",
      "RACK"
    ],
    "letterPool": [
      "C",
      "A",
      "A",
      "B",
      "I",
      "I",
      "N",
      "N",
      "E",
      "E",
      "T",
      "T",
      "U",
      "K",
      "R",
      "R",
      "O",
      "S"
    ],
    "poolString": "CAABIINNEETTUKRROS"
  },
  {
    "levelNumber": 94,
    "category": "Weather Phenomenon",
    "correctAnswer": "TORNADO",
    "alternativeWords": [
      "MIST",
      "WIND",
      "GALE"
    ],
    "letterPool": [
      "T",
      "O",
      "O",
      "R",
      "R",
      "N",
      "A",
      "A",
      "D",
      "M",
      "I",
      "I",
      "S",
      "W",
      "G",
      "L",
      "E",
      "E"
    ],
    "poolString": "TOORRNAADMIISWGLEE"
  },
  {
    "levelNumber": 95,
    "category": "Building",
    "correctAnswer": "WAREHOUSE",
    "alternativeWords": [
      "CABIN",
      "TOWER",
      "STORE"
    ],
    "letterPool": [
      "W",
      "A",
      "A",
      "R",
      "R",
      "E",
      "E",
      "E",
      "H",
      "O",
      "U",
      "S",
      "C",
      "B",
      "I",
      "I",
      "N",
      "T"
    ],
    "poolString": "WAARREEEHOUSCBIINT"
  },
  {
    "levelNumber": 96,
    "category": "Gemstone",
    "correctAnswer": "AMETHYST",
    "alternativeWords": [
      "LAPIS",
      "CORAL",
      "AMBER"
    ],
    "letterPool": [
      "A",
      "A",
      "M",
      "E",
      "E",
      "T",
      "T",
      "H",
      "Y",
      "S",
      "L",
      "P",
      "I",
      "C",
      "O",
      "R",
      "R",
      "B"
    ],
    "poolString": "AAMEETTHYSLPICORRB"
  },
  {
    "levelNumber": 97,
    "category": "Color",
    "correctAnswer": "CRIMSON",
    "alternativeWords": [
      "PINK",
      "GRAY",
      "GREY"
    ],
    "letterPool": [
      "C",
      "R",
      "R",
      "I",
      "I",
      "M",
      "S",
      "O",
      "O",
      "N",
      "P",
      "K",
      "G",
      "A",
      "A",
      "Y",
      "E",
      "E"
    ],
    "poolString": "CRRIIMSOONPKGAAYEE"
  },
  {
    "levelNumber": 98,
    "category": "Animal",
    "correctAnswer": "KANGAROO",
    "alternativeWords": [
      "WOLF",
      "DEER",
      "SEAL"
    ],
    "letterPool": [
      "K",
      "A",
      "A",
      "A",
      "N",
      "G",
      "R",
      "R",
      "O",
      "O",
      "W",
      "L",
      "F",
      "D",
      "E",
      "E",
      "E",
      "S"
    ],
    "poolString": "KAAANGRROOWLFDEEES"
  },
  {
    "levelNumber": 99,
    "category": "Fruit",
    "correctAnswer": "PAPAYA",
    "alternativeWords": [
      "LIME",
      "KIWI",
      "DATE"
    ],
    "letterPool": [
      "P",
      "P",
      "A",
      "A",
      "A",
      "Y",
      "L",
      "I",
      "I",
      "I",
      "M",
      "E",
      "E",
      "K",
      "W",
      "D",
      "T",
      "R"
    ],
    "poolString": "PPAAAYLIIIMEEKWDTR"
  },
  {
      "levelNumber": 100,
      "category": "Kitchen Appliance",
      "correctAnswer": "OVEN",
      "originalWord": "OVEN",
      "alternativeWords": [
        "FORK",
        "BOWL",
        "TRAY"
      ],
      "letterPool": [
        "O",
        "V",
        "E",
        "N",
        "F",
        "O",
        "R",
        "K",
        "B",
        "W",
        "L",
        "T",
        "R",
        "A",
        "Y",
        "I",
        "S",
        "D"
      ],
      "poolString": "OVENFORKBWLTRAYISD"
      
    }

];

/**
 * Level data for Danish (DA)
 * 100 levels total
 */
const levelDataDA = [
  {
    "levelNumber": 1,
    "category": "Tøj",
    "correctAnswer": "SWEATER",
    "alternativeWords": [
      "BÆLTE",
      "SLIPS",
      "FRAKKE"
    ],
    "letterPool": [
      "S",
      "S",
      "W",
      "E",
      "E",
      "E",
      "A",
      "T",
      "R",
      "R",
      "B",
      "Æ",
      "L",
      "I",
      "P",
      "F",
      "K",
      "K"
    ],
    "poolString": "SSWEEEATRRBÆLIPFKK"
  },
  {
    "levelNumber": 2,
    "category": "Blomst",
    "correctAnswer": "NELLIKE",
    "alternativeWords": [
      "DAHLIA",
      "VALMUE",
      "NARCIS"
    ],
    "letterPool": [
      "N",
      "E",
      "E",
      "E",
      "L",
      "L",
      "I",
      "K",
      "D",
      "A",
      "A",
      "H",
      "V",
      "M",
      "U",
      "R",
      "C",
      "S"
    ],
    "poolString": "NEEELLIKDAAHVMURCS"
  },
  {
    "levelNumber": 3,
    "category": "Skole",
    "correctAnswer": "BOG",
    "alternativeWords": [
      "PEN",
      "HÆFTE",
      "PAPIR"
    ],
    "letterPool": [
      "B",
      "O",
      "G",
      "P",
      "P",
      "E",
      "E",
      "N",
      "N",
      "H",
      "Æ",
      "F",
      "T",
      "T",
      "A",
      "I",
      "R",
      "R"
    ],
    "poolString": "BOGPPEENNHÆFTTAIRR"
  },
  {
    "levelNumber": 4,
    "category": "Møbel",
    "correctAnswer": "LÆNESTOL",
    "alternativeWords": [
      "BÆNK",
      "SKAB",
      "REOL"
    ],
    "letterPool": [
      "L",
      "L",
      "Æ",
      "N",
      "N",
      "E",
      "E",
      "S",
      "T",
      "T",
      "O",
      "B",
      "K",
      "A",
      "A",
      "R",
      "R",
      "I"
    ],
    "poolString": "LLÆNNEESTTOBKAARRI"
  },
  {
    "levelNumber": 5,
    "category": "Frugt",
    "correctAnswer": "ÆBLE",
    "alternativeWords": [
      "PÆRE",
      "LIME",
      "DRUE"
    ],
    "letterPool": [
      "Æ",
      "B",
      "L",
      "E",
      "E",
      "P",
      "R",
      "R",
      "I",
      "I",
      "M",
      "D",
      "D",
      "U",
      "N",
      "T",
      "A",
      "S"
    ],
    "poolString": "ÆBLEEPRRIIMDDUNTAS"
  },
  {
    "levelNumber": 6,
    "category": "Tøj",
    "correctAnswer": "SKJORTE",
    "alternativeWords": [
      "JEANS",
      "KJOLE",
      "DRAGT"
    ],
    "letterPool": [
      "S",
      "K",
      "J",
      "O",
      "R",
      "R",
      "T",
      "T",
      "E",
      "E",
      "A",
      "A",
      "N",
      "N",
      "L",
      "D",
      "G",
      "I"
    ],
    "poolString": "SKJORRTTEEAANNLDGI"
  },
  {
    "levelNumber": 7,
    "category": "Drikke",
    "correctAnswer": "VAND",
    "alternativeWords": [
      "TE",
      "ØL",
      "VIN"
    ],
    "letterPool": [
      "V",
      "A",
      "A",
      "N",
      "N",
      "D",
      "D",
      "T",
      "T",
      "E",
      "E",
      "Ø",
      "L",
      "L",
      "I",
      "I",
      "R",
      "S"
    ],
    "poolString": "VAANNDDTTEEØLLIIRS"
  },
  {
    "levelNumber": 8,
    "category": "Flod",
    "correctAnswer": "NILEN",
    "alternativeWords": [
      "Å",
      "ELV",
      "BÆK"
    ],
    "letterPool": [
      "N",
      "N",
      "N",
      "I",
      "I",
      "L",
      "E",
      "E",
      "Å",
      "V",
      "B",
      "Æ",
      "K",
      "R",
      "T",
      "A",
      "S",
      "D"
    ],
    "poolString": "NNNIILEEÅVBÆKRTASD"
  },
  {
    "levelNumber": 9,
    "category": "Land",
    "correctAnswer": "DANMARK",
    "alternativeWords": [
      "USA",
      "KINA",
      "PERU"
    ],
    "letterPool": [
      "D",
      "A",
      "A",
      "A",
      "N",
      "N",
      "M",
      "R",
      "R",
      "K",
      "U",
      "S",
      "I",
      "I",
      "P",
      "E",
      "E",
      "T"
    ],
    "poolString": "DAAANNMRRKUSIIPEET"
  },
  {
    "levelNumber": 10,
    "category": "Træ",
    "correctAnswer": "KASTANJE",
    "alternativeWords": [
      "TRÆ",
      "ROD",
      "BARK"
    ],
    "letterPool": [
      "K",
      "A",
      "A",
      "A",
      "S",
      "T",
      "T",
      "N",
      "N",
      "J",
      "E",
      "E",
      "R",
      "R",
      "Æ",
      "O",
      "D",
      "B"
    ],
    "poolString": "KAAASTTNNJEERRÆODB"
  },
  {
    "levelNumber": 11,
    "category": "Skole",
    "correctAnswer": "BLYANT",
    "alternativeWords": [
      "TAVLE",
      "KRIDT",
      "SVAMP"
    ],
    "letterPool": [
      "B",
      "L",
      "Y",
      "A",
      "N",
      "N",
      "T",
      "V",
      "E",
      "E",
      "K",
      "R",
      "R",
      "I",
      "D",
      "S",
      "M",
      "P"
    ],
    "poolString": "BLYANNTVEEKRRIDSMP"
  },
  {
    "levelNumber": 12,
    "category": "Frugt",
    "correctAnswer": "BANAN",
    "alternativeWords": [
      "KIWI",
      "MANGO",
      "MELON"
    ],
    "letterPool": [
      "B",
      "A",
      "A",
      "N",
      "N",
      "N",
      "K",
      "I",
      "I",
      "W",
      "M",
      "G",
      "O",
      "E",
      "E",
      "L",
      "R",
      "T"
    ],
    "poolString": "BAANNNKIIWMGOEELRT"
  },
  {
    "levelNumber": 13,
    "category": "Møbel",
    "correctAnswer": "BORD",
    "alternativeWords": [
      "STOL",
      "SENG",
      "SOFA"
    ],
    "letterPool": [
      "B",
      "O",
      "R",
      "R",
      "D",
      "S",
      "T",
      "T",
      "L",
      "E",
      "E",
      "N",
      "N",
      "G",
      "F",
      "A",
      "A",
      "I"
    ],
    "poolString": "BORRDSTTLEENNGFAAI"
  },
  {
    "levelNumber": 14,
    "category": "Træ",
    "correctAnswer": "EG",
    "alternativeWords": [
      "ÆL",
      "BØG",
      "FYR"
    ],
    "letterPool": [
      "E",
      "E",
      "G",
      "Æ",
      "L",
      "L",
      "B",
      "Ø",
      "F",
      "Y",
      "R",
      "R",
      "N",
      "T",
      "A",
      "I",
      "S",
      "D"
    ],
    "poolString": "EEGÆLLBØFYRRNTAISD"
  },
  {
    "levelNumber": 15,
    "category": "Flod",
    "correctAnswer": "ELBEN",
    "alternativeWords": [
      "LØB",
      "FLOD",
      "STRØM"
    ],
    "letterPool": [
      "E",
      "E",
      "E",
      "L",
      "B",
      "N",
      "N",
      "Ø",
      "F",
      "O",
      "D",
      "S",
      "T",
      "T",
      "R",
      "R",
      "M",
      "A"
    ],
    "poolString": "EEELBNNØFODSTTRRMA"
  },
  {
    "levelNumber": 16,
    "category": "Sport",
    "correctAnswer": "SVØMNING",
    "alternativeWords": [
      "SPRING",
      "DISKOS",
      "HAMMER"
    ],
    "letterPool": [
      "S",
      "S",
      "V",
      "Ø",
      "M",
      "M",
      "N",
      "N",
      "I",
      "G",
      "P",
      "R",
      "D",
      "K",
      "O",
      "H",
      "A",
      "E"
    ],
    "poolString": "SSVØMMNNIGPRDKOHAE"
  },
  {
    "levelNumber": 17,
    "category": "Blomst",
    "correctAnswer": "TULIPAN",
    "alternativeWords": [
      "LILJE",
      "ORKIDE",
      "ASTERS"
    ],
    "letterPool": [
      "T",
      "U",
      "L",
      "L",
      "I",
      "P",
      "A",
      "N",
      "J",
      "E",
      "E",
      "O",
      "R",
      "R",
      "K",
      "D",
      "S",
      "S"
    ],
    "poolString": "TULLIPANJEEORRKDSS"
  },
  {
    "levelNumber": 18,
    "category": "Frugt",
    "correctAnswer": "KIRSEBÆR",
    "alternativeWords": [
      "BLÅBÆR",
      "FERSKEN",
      "ABRIKOS"
    ],
    "letterPool": [
      "K",
      "I",
      "R",
      "R",
      "R",
      "S",
      "E",
      "E",
      "E",
      "B",
      "B",
      "Æ",
      "L",
      "Å",
      "F",
      "N",
      "A",
      "O"
    ],
    "poolString": "KIRRRSEEEBBÆLÅFNAO"
  },
  {
    "levelNumber": 19,
    "category": "Grøntsag",
    "correctAnswer": "TOMAT",
    "alternativeWords": [
      "ROE",
      "MAJS",
      "AGURK"
    ],
    "letterPool": [
      "T",
      "T",
      "T",
      "O",
      "M",
      "A",
      "A",
      "R",
      "R",
      "E",
      "E",
      "J",
      "S",
      "G",
      "U",
      "K",
      "N",
      "I"
    ],
    "poolString": "TTTOMAARREEJSGUKNI"
  },
  {
    "levelNumber": 20,
    "category": "Farve",
    "correctAnswer": "GRØN",
    "alternativeWords": [
      "PINK",
      "ROSA",
      "BRUN"
    ],
    "letterPool": [
      "G",
      "R",
      "R",
      "Ø",
      "N",
      "N",
      "P",
      "I",
      "I",
      "K",
      "O",
      "S",
      "A",
      "A",
      "B",
      "U",
      "E",
      "T"
    ],
    "poolString": "GRRØNNPIIKOSAABUET"
  },
  {
    "levelNumber": 21,
    "category": "Møbel",
    "correctAnswer": "SKAMMEL",
    "alternativeWords": [
      "SKÆNK",
      "SPEJL",
      "LAMPE"
    ],
    "letterPool": [
      "S",
      "K",
      "K",
      "A",
      "A",
      "M",
      "M",
      "E",
      "E",
      "L",
      "Æ",
      "N",
      "N",
      "P",
      "J",
      "R",
      "T",
      "I"
    ],
    "poolString": "SKKAAMMEELÆNNPJRTI"
  },
  {
    "levelNumber": 22,
    "category": "Musik",
    "correctAnswer": "TROMMER",
    "alternativeWords": [
      "HARPE",
      "CELLO",
      "FAGOT"
    ],
    "letterPool": [
      "T",
      "R",
      "R",
      "R",
      "O",
      "M",
      "M",
      "E",
      "E",
      "H",
      "A",
      "P",
      "C",
      "L",
      "L",
      "F",
      "G",
      "N"
    ],
    "poolString": "TRRROMMEEHAPCLLFGN"
  },
  {
    "levelNumber": 23,
    "category": "Fisk",
    "correctAnswer": "LAKS",
    "alternativeWords": [
      "ÅL",
      "TUN",
      "HAJ"
    ],
    "letterPool": [
      "L",
      "A",
      "A",
      "K",
      "S",
      "S",
      "Å",
      "T",
      "T",
      "U",
      "N",
      "N",
      "H",
      "J",
      "E",
      "R",
      "I",
      "D"
    ],
    "poolString": "LAAKSSÅTTUNNHJERID"
  },
  {
    "levelNumber": 24,
    "category": "Drikke",
    "correctAnswer": "KAKAO",
    "alternativeWords": [
      "COLA",
      "JUICE",
      "CIDER"
    ],
    "letterPool": [
      "K",
      "K",
      "A",
      "A",
      "A",
      "O",
      "C",
      "L",
      "J",
      "U",
      "I",
      "E",
      "E",
      "D",
      "R",
      "R",
      "N",
      "T"
    ],
    "poolString": "KKAAAOCLJUIEEDRRNT"
  },
  {
    "levelNumber": 25,
    "category": "Grøntsag",
    "correctAnswer": "SPINAT",
    "alternativeWords": [
      "ASPARGES",
      "ARTISKOK",
      "AUBERGINE"
    ],
    "letterPool": [
      "S",
      "S",
      "P",
      "I",
      "N",
      "A",
      "A",
      "T",
      "R",
      "G",
      "E",
      "E",
      "E",
      "K",
      "K",
      "O",
      "U",
      "B"
    ],
    "poolString": "SSPINAATRGEEEKKOUB"
  },
  {
    "levelNumber": 26,
    "category": "Vejr",
    "correctAnswer": "SOL",
    "alternativeWords": [
      "IS",
      "SNE",
      "DIS"
    ],
    "letterPool": [
      "S",
      "S",
      "O",
      "O",
      "L",
      "L",
      "I",
      "I",
      "N",
      "N",
      "E",
      "E",
      "E",
      "D",
      "D",
      "R",
      "T",
      "A"
    ],
    "poolString": "SSOOLLIINNEEEDDRTA"
  },
  {
    "levelNumber": 27,
    "category": "Tøj",
    "correctAnswer": "BUKSER",
    "alternativeWords": [
      "VEST",
      "BLUSE",
      "JAKKE"
    ],
    "letterPool": [
      "B",
      "U",
      "K",
      "K",
      "S",
      "E",
      "E",
      "R",
      "R",
      "V",
      "T",
      "T",
      "L",
      "J",
      "A",
      "A",
      "N",
      "I"
    ],
    "poolString": "BUKKSEERRVTTLJAANI"
  },
  {
    "levelNumber": 28,
    "category": "Køkken",
    "correctAnswer": "GAFFEL",
    "alternativeWords": [
      "SKÅL",
      "GLAS",
      "KANDE"
    ],
    "letterPool": [
      "G",
      "A",
      "A",
      "F",
      "F",
      "E",
      "E",
      "L",
      "S",
      "S",
      "K",
      "Å",
      "N",
      "N",
      "D",
      "R",
      "T",
      "I"
    ],
    "poolString": "GAAFFEELSSKÅNNDRTI"
  },
  {
    "levelNumber": 29,
    "category": "Land",
    "correctAnswer": "SVERIGE",
    "alternativeWords": [
      "JAPAN",
      "KOREA",
      "CHILE"
    ],
    "letterPool": [
      "S",
      "V",
      "E",
      "E",
      "E",
      "R",
      "I",
      "G",
      "J",
      "A",
      "A",
      "P",
      "N",
      "K",
      "O",
      "C",
      "H",
      "L"
    ],
    "poolString": "SVEEERIGJAAPNKOCHL"
  },
  {
    "levelNumber": 30,
    "category": "Træ",
    "correctAnswer": "GRAN",
    "alternativeWords": [
      "PIL",
      "LIND",
      "POPPEL"
    ],
    "letterPool": [
      "G",
      "R",
      "R",
      "A",
      "A",
      "N",
      "N",
      "P",
      "P",
      "P",
      "I",
      "I",
      "L",
      "D",
      "O",
      "E",
      "E",
      "T"
    ],
    "poolString": "GRRAANNPPPIILDOEET"
  },
  {
    "levelNumber": 31,
    "category": "Fugl",
    "correctAnswer": "KRAGE",
    "alternativeWords": [
      "STÆR",
      "HØNE",
      "HANE"
    ],
    "letterPool": [
      "K",
      "R",
      "R",
      "A",
      "A",
      "G",
      "E",
      "E",
      "S",
      "S",
      "T",
      "T",
      "Æ",
      "H",
      "Ø",
      "N",
      "N",
      "I"
    ],
    "poolString": "KRRAAGEESSTTÆHØNNI"
  },
  {
    "levelNumber": 32,
    "category": "Dyr",
    "correctAnswer": "BJØRN",
    "alternativeWords": [
      "HARE",
      "LØVE",
      "HVAL"
    ],
    "letterPool": [
      "B",
      "J",
      "Ø",
      "R",
      "R",
      "N",
      "N",
      "H",
      "A",
      "A",
      "E",
      "E",
      "L",
      "V",
      "T",
      "I",
      "S",
      "D"
    ],
    "poolString": "BJØRRNNHAAEELVTISD"
  },
  {
    "levelNumber": 33,
    "category": "Køkken",
    "correctAnswer": "TALLERKEN",
    "alternativeWords": [
      "GRYDE",
      "PANDE",
      "KEDEL"
    ],
    "letterPool": [
      "T",
      "T",
      "A",
      "A",
      "L",
      "L",
      "E",
      "E",
      "E",
      "R",
      "R",
      "K",
      "N",
      "N",
      "G",
      "Y",
      "D",
      "P"
    ],
    "poolString": "TTAALLEEERRKNNGYDP"
  },
  {
    "levelNumber": 34,
    "category": "Farve",
    "correctAnswer": "ORANGE",
    "alternativeWords": [
      "SORT",
      "HVID",
      "GULD"
    ],
    "letterPool": [
      "O",
      "R",
      "R",
      "A",
      "N",
      "N",
      "G",
      "E",
      "E",
      "S",
      "T",
      "T",
      "H",
      "V",
      "I",
      "D",
      "U",
      "L"
    ],
    "poolString": "ORRANNGEESTTHVIDUL"
  },
  {
    "levelNumber": 35,
    "category": "Tal",
    "correctAnswer": "ET",
    "alternativeWords": [
      "TO",
      "NI",
      "TI"
    ],
    "letterPool": [
      "E",
      "E",
      "E",
      "T",
      "T",
      "O",
      "O",
      "N",
      "N",
      "N",
      "I",
      "I",
      "R",
      "R",
      "A",
      "S",
      "D",
      "L"
    ],
    "poolString": "EEETTOONNNIIRRASDL"
  },
  {
    "levelNumber": 36,
    "category": "Kalender",
    "correctAnswer": "MARTS",
    "alternativeWords": [
      "MAJ",
      "TIME",
      "JUNI"
    ],
    "letterPool": [
      "M",
      "A",
      "A",
      "R",
      "R",
      "T",
      "T",
      "S",
      "S",
      "J",
      "I",
      "I",
      "E",
      "E",
      "U",
      "N",
      "N",
      "D"
    ],
    "poolString": "MAARRTTSSJIIEEUNND"
  },
  {
    "levelNumber": 37,
    "category": "Musik",
    "correctAnswer": "KLAVER",
    "alternativeWords": [
      "GONG",
      "RYTME",
      "BANJO"
    ],
    "letterPool": [
      "K",
      "L",
      "A",
      "V",
      "E",
      "E",
      "R",
      "R",
      "G",
      "G",
      "O",
      "N",
      "N",
      "Y",
      "T",
      "M",
      "B",
      "J"
    ],
    "poolString": "KLAVEERRGGONNYTMBJ"
  },
  {
    "levelNumber": 38,
    "category": "Land",
    "correctAnswer": "FINLAND",
    "alternativeWords": [
      "ISLAND",
      "INDIEN",
      "CANADA"
    ],
    "letterPool": [
      "F",
      "I",
      "I",
      "I",
      "N",
      "N",
      "N",
      "L",
      "A",
      "A",
      "A",
      "D",
      "S",
      "E",
      "E",
      "C",
      "R",
      "T"
    ],
    "poolString": "FIIINNNLAAADSEECRT"
  },
  {
    "levelNumber": 39,
    "category": "Kalender",
    "correctAnswer": "UGEDAG",
    "alternativeWords": [
      "APRIL",
      "SEKUND",
      "JANUAR"
    ],
    "letterPool": [
      "U",
      "G",
      "G",
      "E",
      "E",
      "D",
      "A",
      "A",
      "P",
      "R",
      "R",
      "I",
      "L",
      "S",
      "K",
      "N",
      "N",
      "J"
    ],
    "poolString": "UGGEEDAAPRRILSKNNJ"
  },
  {
    "levelNumber": 40,
    "category": "Flod",
    "correctAnswer": "SEINEN",
    "alternativeWords": [
      "VANDLØB",
      "BREDDEN",
      "FLODLEJE"
    ],
    "letterPool": [
      "S",
      "E",
      "E",
      "I",
      "N",
      "N",
      "V",
      "A",
      "D",
      "D",
      "L",
      "L",
      "Ø",
      "B",
      "R",
      "F",
      "O",
      "J"
    ],
    "poolString": "SEEINNVADDLLØBRFOJ"
  },
  {
    "levelNumber": 41,
    "category": "Natur",
    "correctAnswer": "SKOV",
    "alternativeWords": [
      "Ø",
      "SØ",
      "HAV"
    ],
    "letterPool": [
      "S",
      "S",
      "K",
      "O",
      "O",
      "V",
      "Ø",
      "H",
      "A",
      "A",
      "E",
      "E",
      "R",
      "N",
      "T",
      "I",
      "D",
      "L"
    ],
    "poolString": "SSKOOVØHAAEERNTIDL"
  },
  {
    "levelNumber": 42,
    "category": "Tøj",
    "correctAnswer": "TRØJE",
    "alternativeWords": [
      "SKO",
      "HAT",
      "HUE"
    ],
    "letterPool": [
      "T",
      "T",
      "R",
      "R",
      "Ø",
      "J",
      "E",
      "E",
      "S",
      "S",
      "K",
      "O",
      "H",
      "A",
      "A",
      "U",
      "N",
      "I"
    ],
    "poolString": "TTRRØJEESSKOHAAUNI"
  },
  {
    "levelNumber": 43,
    "category": "Land",
    "correctAnswer": "NORGE",
    "alternativeWords": [
      "POLEN",
      "KENYA",
      "GHANA"
    ],
    "letterPool": [
      "N",
      "N",
      "O",
      "R",
      "R",
      "G",
      "E",
      "E",
      "P",
      "L",
      "K",
      "Y",
      "A",
      "A",
      "A",
      "H",
      "T",
      "I"
    ],
    "poolString": "NNORRGEEPLKYAAAHTI"
  },
  {
    "levelNumber": 44,
    "category": "Køkken",
    "correctAnswer": "BLENDER",
    "alternativeWords": [
      "MIXER",
      "KOMFUR",
      "FRYSER"
    ],
    "letterPool": [
      "B",
      "L",
      "E",
      "E",
      "E",
      "N",
      "D",
      "R",
      "R",
      "M",
      "I",
      "X",
      "K",
      "O",
      "F",
      "U",
      "Y",
      "S"
    ],
    "poolString": "BLEEENDRRMIXKOFUYS"
  },
  {
    "levelNumber": 45,
    "category": "Fisk",
    "correctAnswer": "ABORRE",
    "alternativeWords": [
      "SEJ",
      "FISK",
      "MULTE"
    ],
    "letterPool": [
      "A",
      "B",
      "O",
      "R",
      "R",
      "R",
      "E",
      "E",
      "S",
      "J",
      "F",
      "I",
      "K",
      "M",
      "U",
      "L",
      "T",
      "N"
    ],
    "poolString": "ABORRREESJFIKMULTN"
  },
  {
    "levelNumber": 46,
    "category": "Sport",
    "correctAnswer": "HÅNDBOLD",
    "alternativeWords": [
      "RONING",
      "SKILØB",
      "SPRINT"
    ],
    "letterPool": [
      "H",
      "Å",
      "N",
      "N",
      "D",
      "D",
      "B",
      "O",
      "L",
      "R",
      "I",
      "G",
      "S",
      "K",
      "Ø",
      "P",
      "T",
      "E"
    ],
    "poolString": "HÅNNDDBOLRIGSKØPTE"
  },
  {
    "levelNumber": 47,
    "category": "Natur",
    "correctAnswer": "KILDE",
    "alternativeWords": [
      "BUGT",
      "MARK",
      "MOSE"
    ],
    "letterPool": [
      "K",
      "I",
      "L",
      "D",
      "E",
      "E",
      "B",
      "U",
      "G",
      "T",
      "T",
      "M",
      "A",
      "R",
      "R",
      "O",
      "S",
      "N"
    ],
    "poolString": "KILDEEBUGTTMARROSN"
  },
  {
    "levelNumber": 48,
    "category": "Mad",
    "correctAnswer": "SMØR",
    "alternativeWords": [
      "RIS",
      "LAM",
      "MÆLK"
    ],
    "letterPool": [
      "S",
      "S",
      "M",
      "Ø",
      "R",
      "R",
      "I",
      "I",
      "L",
      "L",
      "A",
      "A",
      "Æ",
      "K",
      "E",
      "N",
      "T",
      "D"
    ],
    "poolString": "SSMØRRIILLAAÆKENTD"
  },
  {
    "levelNumber": 49,
    "category": "Natur",
    "correctAnswer": "OCEAN",
    "alternativeWords": [
      "ENG",
      "KYST",
      "KLIT"
    ],
    "letterPool": [
      "O",
      "C",
      "E",
      "E",
      "A",
      "A",
      "N",
      "N",
      "G",
      "K",
      "Y",
      "S",
      "T",
      "T",
      "L",
      "I",
      "I",
      "R"
    ],
    "poolString": "OCEEAANNGKYSTTLIIR"
  },
  {
    "levelNumber": 50,
    "category": "Hus",
    "correctAnswer": "TRAPPE",
    "alternativeWords": [
      "KÆLDER",
      "KØKKEN",
      "TOILET"
    ],
    "letterPool": [
      "T",
      "T",
      "R",
      "A",
      "P",
      "P",
      "E",
      "E",
      "K",
      "K",
      "K",
      "Æ",
      "L",
      "D",
      "Ø",
      "N",
      "O",
      "I"
    ],
    "poolString": "TTRAPPEEKKKÆLDØNOI"
  },
  {
    "levelNumber": 51,
    "category": "Musik",
    "correctAnswer": "GUITAR",
    "alternativeWords": [
      "TONE",
      "TUBA",
      "HORN"
    ],
    "letterPool": [
      "G",
      "U",
      "I",
      "I",
      "T",
      "T",
      "A",
      "A",
      "R",
      "R",
      "O",
      "N",
      "N",
      "E",
      "E",
      "B",
      "H",
      "S"
    ],
    "poolString": "GUIITTAARRONNEEBHS"
  },
  {
    "levelNumber": 52,
    "category": "Skole",
    "correctAnswer": "VISKELÆDER",
    "alternativeWords": [
      "TUSCH",
      "TASKE",
      "MAPPE"
    ],
    "letterPool": [
      "V",
      "I",
      "S",
      "K",
      "E",
      "E",
      "L",
      "Æ",
      "D",
      "R",
      "T",
      "U",
      "C",
      "H",
      "A",
      "M",
      "P",
      "P"
    ],
    "poolString": "VISKEELÆDRTUCHAMPP"
  },
  {
    "levelNumber": 53,
    "category": "Krop",
    "correctAnswer": "FOD",
    "alternativeWords": [
      "ØRE",
      "ARM",
      "RYG"
    ],
    "letterPool": [
      "F",
      "O",
      "D",
      "D",
      "Ø",
      "R",
      "R",
      "E",
      "E",
      "A",
      "A",
      "M",
      "Y",
      "G",
      "N",
      "T",
      "I",
      "S"
    ],
    "poolString": "FODDØRREEAAMYGNTIS"
  },
  {
    "levelNumber": 54,
    "category": "Møbel",
    "correctAnswer": "KOMMODE",
    "alternativeWords": [
      "HYLD",
      "PUDE",
      "KISTE"
    ],
    "letterPool": [
      "K",
      "O",
      "O",
      "M",
      "M",
      "D",
      "E",
      "E",
      "H",
      "Y",
      "L",
      "P",
      "U",
      "I",
      "S",
      "T",
      "R",
      "N"
    ],
    "poolString": "KOOMMDEEHYLPUISTRN"
  },
  {
    "levelNumber": 55,
    "category": "Blomst",
    "correctAnswer": "GERBERA",
    "alternativeWords": [
      "PETUNIA",
      "HYACINT",
      "BEGONIA"
    ],
    "letterPool": [
      "G",
      "E",
      "E",
      "E",
      "R",
      "R",
      "R",
      "B",
      "A",
      "P",
      "T",
      "U",
      "N",
      "I",
      "H",
      "Y",
      "C",
      "O"
    ],
    "poolString": "GEEERRRBAPTUNIHYCO"
  },
  {
    "levelNumber": 56,
    "category": "Fisk",
    "correctAnswer": "RØDSPÆTTE",
    "alternativeWords": [
      "KARPE",
      "ROKKE",
      "MAKREL"
    ],
    "letterPool": [
      "R",
      "R",
      "Ø",
      "D",
      "S",
      "P",
      "Æ",
      "T",
      "T",
      "E",
      "E",
      "K",
      "K",
      "A",
      "O",
      "M",
      "L",
      "N"
    ],
    "poolString": "RRØDSPÆTTEEKKAOMLN"
  },
  {
    "levelNumber": 57,
    "category": "Hus",
    "correctAnswer": "DØR",
    "alternativeWords": [
      "TAG",
      "VÆG",
      "GULV"
    ],
    "letterPool": [
      "D",
      "D",
      "Ø",
      "R",
      "R",
      "T",
      "T",
      "A",
      "A",
      "G",
      "V",
      "Æ",
      "U",
      "L",
      "E",
      "N",
      "I",
      "S"
    ],
    "poolString": "DDØRRTTAAGVÆULENIS"
  },
  {
    "levelNumber": 58,
    "category": "Tal",
    "correctAnswer": "ELLEVE",
    "alternativeWords": [
      "TYVE",
      "ATTEN",
      "FEMTEN"
    ],
    "letterPool": [
      "E",
      "E",
      "E",
      "L",
      "L",
      "V",
      "T",
      "T",
      "T",
      "Y",
      "A",
      "A",
      "N",
      "N",
      "F",
      "M",
      "R",
      "I"
    ],
    "poolString": "EEELLVTTTYAANNFMRI"
  },
  {
    "levelNumber": 59,
    "category": "Grøntsag",
    "correctAnswer": "GULEROD",
    "alternativeWords": [
      "LØG",
      "KÅL",
      "ÆRT"
    ],
    "letterPool": [
      "G",
      "U",
      "L",
      "E",
      "E",
      "R",
      "R",
      "O",
      "D",
      "Ø",
      "K",
      "Å",
      "Æ",
      "T",
      "T",
      "N",
      "A",
      "I"
    ],
    "poolString": "GULEERRODØKÅÆTTNAI"
  },
  {
    "levelNumber": 60,
    "category": "Fisk",
    "correctAnswer": "TORSK",
    "alternativeWords": [
      "SILD",
      "GEDDE",
      "ØRRED"
    ],
    "letterPool": [
      "T",
      "T",
      "O",
      "R",
      "R",
      "R",
      "S",
      "K",
      "I",
      "L",
      "D",
      "D",
      "G",
      "E",
      "E",
      "E",
      "Ø",
      "N"
    ],
    "poolString": "TTORRRSKILDDGEEEØN"
  },
  {
    "levelNumber": 61,
    "category": "Blomst",
    "correctAnswer": "ROSE",
    "alternativeWords": [
      "IRIS",
      "VIOL",
      "PÆON"
    ],
    "letterPool": [
      "R",
      "R",
      "O",
      "S",
      "S",
      "E",
      "E",
      "I",
      "I",
      "I",
      "V",
      "L",
      "P",
      "Æ",
      "N",
      "N",
      "T",
      "A"
    ],
    "poolString": "RROSSEEIIIVLPÆNNTA"
  },
  {
    "levelNumber": 62,
    "category": "Kalender",
    "correctAnswer": "MANDAG",
    "alternativeWords": [
      "ÅR",
      "UGE",
      "DAG"
    ],
    "letterPool": [
      "M",
      "A",
      "A",
      "A",
      "N",
      "N",
      "D",
      "D",
      "G",
      "Å",
      "R",
      "R",
      "U",
      "E",
      "E",
      "T",
      "I",
      "S"
    ],
    "poolString": "MAAANNDDGÅRRUEETIS"
  },
  {
    "levelNumber": 63,
    "category": "Krop",
    "correctAnswer": "NÆSE",
    "alternativeWords": [
      "LÆG",
      "HÆL",
      "HUD"
    ],
    "letterPool": [
      "N",
      "N",
      "Æ",
      "S",
      "S",
      "E",
      "E",
      "L",
      "L",
      "G",
      "H",
      "U",
      "D",
      "D",
      "R",
      "T",
      "A",
      "I"
    ],
    "poolString": "NNÆSSEELLGHUDDRTAI"
  },
  {
    "levelNumber": 64,
    "category": "Natur",
    "correctAnswer": "BJERG",
    "alternativeWords": [
      "DAL",
      "KAP",
      "VIG"
    ],
    "letterPool": [
      "B",
      "J",
      "E",
      "E",
      "R",
      "R",
      "G",
      "D",
      "A",
      "A",
      "L",
      "K",
      "P",
      "V",
      "I",
      "I",
      "N",
      "T"
    ],
    "poolString": "BJEERRGDAALKPVIINT"
  },
  {
    "levelNumber": 65,
    "category": "Drikke",
    "correctAnswer": "KAFFE",
    "alternativeWords": [
      "ROM",
      "GIN",
      "SAFT"
    ],
    "letterPool": [
      "K",
      "A",
      "A",
      "F",
      "F",
      "E",
      "E",
      "R",
      "R",
      "O",
      "M",
      "G",
      "I",
      "N",
      "N",
      "S",
      "T",
      "T"
    ],
    "poolString": "KAAFFEERROMGINNSTT"
  },
  {
    "levelNumber": 66,
    "category": "Dyr",
    "correctAnswer": "HUND",
    "alternativeWords": [
      "MUS",
      "ABE",
      "SÆL"
    ],
    "letterPool": [
      "H",
      "U",
      "N",
      "N",
      "D",
      "M",
      "S",
      "S",
      "A",
      "A",
      "B",
      "E",
      "E",
      "Æ",
      "L",
      "R",
      "T",
      "I"
    ],
    "poolString": "HUNNDMSSAABEEÆLRTI"
  },
  {
    "levelNumber": 67,
    "category": "Krop",
    "correctAnswer": "HOVED",
    "alternativeWords": [
      "BEN",
      "LÅR",
      "KNÆ"
    ],
    "letterPool": [
      "H",
      "O",
      "V",
      "E",
      "E",
      "D",
      "B",
      "N",
      "N",
      "L",
      "Å",
      "R",
      "R",
      "K",
      "Æ",
      "T",
      "A",
      "I"
    ],
    "poolString": "HOVEEDBNNLÅRRKÆTAI"
  },
  {
    "levelNumber": 68,
    "category": "Vejr",
    "correctAnswer": "REGN",
    "alternativeWords": [
      "DUG",
      "RIM",
      "LYN"
    ],
    "letterPool": [
      "R",
      "R",
      "E",
      "E",
      "G",
      "N",
      "N",
      "D",
      "D",
      "U",
      "I",
      "I",
      "M",
      "L",
      "Y",
      "T",
      "A",
      "S"
    ],
    "poolString": "RREEGNNDDUIIMLYTAS"
  },
  {
    "levelNumber": 69,
    "category": "Sport",
    "correctAnswer": "BASKETBALL",
    "alternativeWords": [
      "SQUASH",
      "HOCKEY",
      "KARATE"
    ],
    "letterPool": [
      "B",
      "B",
      "A",
      "A",
      "S",
      "S",
      "K",
      "E",
      "T",
      "L",
      "L",
      "Q",
      "U",
      "H",
      "O",
      "C",
      "Y",
      "R"
    ],
    "poolString": "BBAASSKETLLQUHOCYR"
  },
  {
    "levelNumber": 70,
    "category": "Dyr",
    "correctAnswer": "ROTTE",
    "alternativeWords": [
      "EGERN",
      "GIRAF",
      "ZEBRA"
    ],
    "letterPool": [
      "R",
      "R",
      "O",
      "T",
      "T",
      "T",
      "E",
      "E",
      "E",
      "G",
      "N",
      "N",
      "I",
      "A",
      "A",
      "F",
      "Z",
      "B"
    ],
    "poolString": "RROTTTEEEGNNIAAFZB"
  },
  {
    "levelNumber": 71,
    "category": "Hus",
    "correctAnswer": "VINDUE",
    "alternativeWords": [
      "GANG",
      "HAVE",
      "SKUR"
    ],
    "letterPool": [
      "V",
      "I",
      "N",
      "N",
      "D",
      "U",
      "E",
      "E",
      "G",
      "G",
      "A",
      "A",
      "H",
      "S",
      "K",
      "R",
      "R",
      "T"
    ],
    "poolString": "VINNDUEEGGAAHSKRRT"
  },
  {
    "levelNumber": 72,
    "category": "Grøntsag",
    "correctAnswer": "SALAT",
    "alternativeWords": [
      "BØNNE",
      "PEBER",
      "CHILI"
    ],
    "letterPool": [
      "S",
      "A",
      "A",
      "L",
      "T",
      "B",
      "Ø",
      "N",
      "N",
      "E",
      "E",
      "E",
      "P",
      "R",
      "C",
      "H",
      "I",
      "I"
    ],
    "poolString": "SAALTBØNNEEEPRCHII"
  },
  {
    "levelNumber": 73,
    "category": "Farve",
    "correctAnswer": "LILLA",
    "alternativeWords": [
      "SØLV",
      "BEIGE",
      "BRONZE"
    ],
    "letterPool": [
      "L",
      "L",
      "L",
      "I",
      "A",
      "S",
      "Ø",
      "V",
      "B",
      "E",
      "E",
      "E",
      "G",
      "R",
      "R",
      "O",
      "N",
      "Z"
    ],
    "poolString": "LLLIASØVBEEEGRRONZ"
  },
  {
    "levelNumber": 74,
    "category": "By",
    "correctAnswer": "KØBENHAVN",
    "alternativeWords": [
      "KØGE",
      "VEJLE",
      "AARHUS"
    ],
    "letterPool": [
      "K",
      "Ø",
      "B",
      "E",
      "E",
      "E",
      "N",
      "N",
      "H",
      "A",
      "A",
      "V",
      "G",
      "J",
      "L",
      "R",
      "U",
      "S"
    ],
    "poolString": "KØBEEENNHAAVGJLRUS"
  },
  {
    "levelNumber": 75,
    "category": "Mad",
    "correctAnswer": "BRØD",
    "alternativeWords": [
      "ÆG",
      "OST",
      "KØD"
    ],
    "letterPool": [
      "B",
      "R",
      "R",
      "Ø",
      "D",
      "D",
      "Æ",
      "G",
      "O",
      "S",
      "S",
      "T",
      "T",
      "K",
      "E",
      "N",
      "A",
      "I"
    ],
    "poolString": "BRRØDDÆGOSSTTKENAI"
  },
  {
    "levelNumber": 76,
    "category": "Krop",
    "correctAnswer": "HÅND",
    "alternativeWords": [
      "TÅ",
      "HÅR",
      "ØJE"
    ],
    "letterPool": [
      "H",
      "Å",
      "N",
      "N",
      "D",
      "D",
      "T",
      "T",
      "R",
      "R",
      "Ø",
      "J",
      "E",
      "E",
      "A",
      "I",
      "S",
      "L"
    ],
    "poolString": "HÅNNDDTTRRØJEEAISL"
  },
  {
    "levelNumber": 77,
    "category": "Drikke",
    "correctAnswer": "SODAVAND",
    "alternativeWords": [
      "VODKA",
      "LIKØR",
      "WHISKY"
    ],
    "letterPool": [
      "S",
      "O",
      "D",
      "D",
      "A",
      "A",
      "V",
      "N",
      "K",
      "L",
      "I",
      "Ø",
      "R",
      "R",
      "W",
      "H",
      "Y",
      "E"
    ],
    "poolString": "SODDAAVNKLIØRRWHYE"
  },
  {
    "levelNumber": 78,
    "category": "Vejr",
    "correctAnswer": "VIND",
    "alternativeWords": [
      "STORM",
      "ORKAN",
      "TORDEN"
    ],
    "letterPool": [
      "V",
      "I",
      "I",
      "N",
      "N",
      "D",
      "S",
      "T",
      "T",
      "O",
      "R",
      "R",
      "M",
      "K",
      "A",
      "A",
      "E",
      "E"
    ],
    "poolString": "VIINNDSTTORRMKAAEE"
  },
  {
    "levelNumber": 79,
    "category": "Køkken",
    "correctAnswer": "KNIV",
    "alternativeWords": [
      "SKE",
      "KOP",
      "OVN"
    ],
    "letterPool": [
      "K",
      "N",
      "N",
      "I",
      "I",
      "V",
      "S",
      "S",
      "E",
      "E",
      "O",
      "O",
      "P",
      "R",
      "T",
      "A",
      "D",
      "L"
    ],
    "poolString": "KNNIIVSSEEOOPRTADL"
  },
  {
    "levelNumber": 80,
    "category": "Farve",
    "correctAnswer": "RØD",
    "alternativeWords": [
      "BLÅ",
      "GUL",
      "GRÅ"
    ],
    "letterPool": [
      "R",
      "R",
      "Ø",
      "D",
      "D",
      "B",
      "L",
      "L",
      "Å",
      "G",
      "U",
      "E",
      "N",
      "T",
      "A",
      "I",
      "S",
      "O"
    ],
    "poolString": "RRØDDBLLÅGUENTAISO"
  },
  {
    "levelNumber": 81,
    "category": "Flod",
    "correctAnswer": "GANGES",
    "alternativeWords": [
      "KANAL",
      "AFLØB",
      "TILLØB"
    ],
    "letterPool": [
      "G",
      "G",
      "A",
      "A",
      "N",
      "N",
      "E",
      "E",
      "S",
      "K",
      "L",
      "L",
      "F",
      "Ø",
      "B",
      "T",
      "I",
      "R"
    ],
    "poolString": "GGAANNEESKLLFØBTIR"
  },
  {
    "levelNumber": 82,
    "category": "Sport",
    "correctAnswer": "FODBOLD",
    "alternativeWords": [
      "GOLF",
      "JUDO",
      "KANO"
    ],
    "letterPool": [
      "F",
      "O",
      "O",
      "D",
      "D",
      "B",
      "L",
      "G",
      "J",
      "U",
      "K",
      "A",
      "A",
      "N",
      "N",
      "E",
      "R",
      "T"
    ],
    "poolString": "FOODDBLGJUKAANNERT"
  },
  {
    "levelNumber": 83,
    "category": "Mad",
    "correctAnswer": "YOGHURT",
    "alternativeWords": [
      "KAGE",
      "TART",
      "KIKS"
    ],
    "letterPool": [
      "Y",
      "O",
      "G",
      "H",
      "U",
      "R",
      "R",
      "T",
      "T",
      "T",
      "K",
      "K",
      "A",
      "E",
      "E",
      "I",
      "S",
      "N"
    ],
    "poolString": "YOGHURRTTTKKAEEISN"
  },
  {
    "levelNumber": 84,
    "category": "Tal",
    "correctAnswer": "FIRE",
    "alternativeWords": [
      "SEKS",
      "OTTE",
      "TOLV"
    ],
    "letterPool": [
      "F",
      "I",
      "I",
      "R",
      "R",
      "E",
      "E",
      "S",
      "S",
      "K",
      "O",
      "T",
      "T",
      "T",
      "L",
      "V",
      "N",
      "A"
    ],
    "poolString": "FIIRREESSKOTTTLVNA"
  },
  {
    "levelNumber": 85,
    "category": "Fugl",
    "correctAnswer": "SOLSORT",
    "alternativeWords": [
      "MÅGE",
      "TERNE",
      "LUNDE"
    ],
    "letterPool": [
      "S",
      "S",
      "O",
      "O",
      "L",
      "R",
      "R",
      "T",
      "M",
      "Å",
      "G",
      "E",
      "E",
      "E",
      "N",
      "N",
      "U",
      "D"
    ],
    "poolString": "SSOOLRRTMÅGEEENNUD"
  },
  {
    "levelNumber": 86,
    "category": "Træ",
    "correctAnswer": "BIRK",
    "alternativeWords": [
      "ELM",
      "ASK",
      "LØN"
    ],
    "letterPool": [
      "B",
      "I",
      "I",
      "R",
      "R",
      "K",
      "E",
      "E",
      "L",
      "M",
      "A",
      "A",
      "S",
      "S",
      "Ø",
      "N",
      "N",
      "T"
    ],
    "poolString": "BIIRRKEELMAASSØNNT"
  },
  {
    "levelNumber": 87,
    "category": "Musik",
    "correctAnswer": "SANG",
    "alternativeWords": [
      "BAS",
      "OBO",
      "TAKT"
    ],
    "letterPool": [
      "S",
      "S",
      "A",
      "A",
      "N",
      "N",
      "G",
      "B",
      "O",
      "O",
      "T",
      "T",
      "T",
      "K",
      "E",
      "R",
      "I",
      "D"
    ],
    "poolString": "SSAANNGBOOTTTKERID"
  },
  {
    "levelNumber": 88,
    "category": "Mad",
    "correctAnswer": "FLØDE",
    "alternativeWords": [
      "SLIK",
      "KALV",
      "SVIN"
    ],
    "letterPool": [
      "F",
      "L",
      "Ø",
      "D",
      "E",
      "E",
      "S",
      "S",
      "I",
      "I",
      "K",
      "A",
      "A",
      "V",
      "N",
      "N",
      "R",
      "T"
    ],
    "poolString": "FLØDEESSIIKAAVNNRT"
  },
  {
    "levelNumber": 89,
    "category": "By",
    "correctAnswer": "ODENSE",
    "alternativeWords": [
      "VIBORG",
      "AALBORG",
      "ESBJERG"
    ],
    "letterPool": [
      "O",
      "D",
      "E",
      "E",
      "E",
      "N",
      "N",
      "S",
      "V",
      "I",
      "B",
      "R",
      "R",
      "G",
      "A",
      "A",
      "L",
      "J"
    ],
    "poolString": "ODEEENNSVIBRRGAALJ"
  },
  {
    "levelNumber": 90,
    "category": "Hus",
    "correctAnswer": "LOFT",
    "alternativeWords": [
      "STUE",
      "ENTRE",
      "ALTAN"
    ],
    "letterPool": [
      "L",
      "O",
      "F",
      "T",
      "T",
      "S",
      "U",
      "E",
      "E",
      "E",
      "N",
      "N",
      "R",
      "R",
      "A",
      "A",
      "A",
      "I"
    ],
    "poolString": "LOFTTSUEEENNRRAAAI"
  },
  {
    "levelNumber": 91,
    "category": "Dyr",
    "correctAnswer": "ELEFANT",
    "alternativeWords": [
      "KAT",
      "RÆV",
      "ULV"
    ],
    "letterPool": [
      "E",
      "E",
      "E",
      "L",
      "F",
      "A",
      "A",
      "N",
      "N",
      "T",
      "T",
      "K",
      "R",
      "R",
      "Æ",
      "V",
      "U",
      "I"
    ],
    "poolString": "EEELFAANNTTKRRÆVUI"
  },
  {
    "levelNumber": 92,
    "category": "Frugt",
    "correctAnswer": "APPELSIN",
    "alternativeWords": [
      "CITRON",
      "BLOMME",
      "PAPAYA"
    ],
    "letterPool": [
      "A",
      "A",
      "A",
      "P",
      "P",
      "E",
      "L",
      "S",
      "I",
      "N",
      "C",
      "T",
      "R",
      "O",
      "B",
      "M",
      "M",
      "Y"
    ],
    "poolString": "AAAPPELSINCTROBMMY"
  },
  {
    "levelNumber": 93,
    "category": "Skole",
    "correctAnswer": "LINEAL",
    "alternativeWords": [
      "ATLAS",
      "PASSER",
      "RYGSÆK"
    ],
    "letterPool": [
      "L",
      "L",
      "I",
      "N",
      "E",
      "E",
      "A",
      "A",
      "T",
      "S",
      "S",
      "P",
      "R",
      "R",
      "Y",
      "G",
      "Æ",
      "K"
    ],
    "poolString": "LLINEEAATSSPRRYGÆK"
  },
  {
    "levelNumber": 94,
    "category": "By",
    "correctAnswer": "ROSKILDE",
    "alternativeWords": [
      "HILLERØD",
      "SILKEBORG",
      "HOLSTEBRO"
    ],
    "letterPool": [
      "R",
      "R",
      "O",
      "O",
      "S",
      "K",
      "I",
      "L",
      "L",
      "D",
      "E",
      "E",
      "H",
      "Ø",
      "B",
      "G",
      "T",
      "N"
    ],
    "poolString": "RROOSKILLDEEHØBGTN"
  },
  {
    "levelNumber": 95,
    "category": "Fugl",
    "correctAnswer": "SPURV",
    "alternativeWords": [
      "DUE",
      "ØRN",
      "AND"
    ],
    "letterPool": [
      "S",
      "S",
      "P",
      "U",
      "R",
      "R",
      "V",
      "D",
      "D",
      "E",
      "E",
      "Ø",
      "N",
      "N",
      "A",
      "A",
      "T",
      "I"
    ],
    "poolString": "SSPURRVDDEEØNNAATI"
  },
  {
    "levelNumber": 96,
    "category": "Vejr",
    "correctAnswer": "SLUD",
    "alternativeWords": [
      "SKY",
      "HAGL",
      "TÅGE"
    ],
    "letterPool": [
      "S",
      "L",
      "U",
      "D",
      "K",
      "Y",
      "H",
      "A",
      "A",
      "G",
      "T",
      "T",
      "Å",
      "E",
      "E",
      "R",
      "N",
      "I"
    ],
    "poolString": "SLUDKYHAAGTTÅEERNI"
  },
  {
    "levelNumber": 97,
    "category": "Tal",
    "correctAnswer": "NUL",
    "alternativeWords": [
      "TRE",
      "FEM",
      "SYV"
    ],
    "letterPool": [
      "N",
      "N",
      "U",
      "L",
      "T",
      "T",
      "R",
      "R",
      "E",
      "E",
      "F",
      "M",
      "S",
      "S",
      "Y",
      "V",
      "A",
      "I"
    ],
    "poolString": "NNULTTRREEFMSSYVAI"
  },
  {
    "levelNumber": 98,
    "category": "Fugl",
    "correctAnswer": "SVANE",
    "alternativeWords": [
      "GÅS",
      "FALK",
      "UGLE"
    ],
    "letterPool": [
      "S",
      "S",
      "V",
      "A",
      "A",
      "N",
      "N",
      "E",
      "E",
      "G",
      "Å",
      "F",
      "L",
      "K",
      "U",
      "R",
      "T",
      "I"
    ],
    "poolString": "SSVAANNEEGÅFLKURTI"
  },
  {
    "levelNumber": 99,
    "category": "By",
    "correctAnswer": "RANDERS",
    "alternativeWords": [
      "KOLDING",
      "HORSENS",
      "HERNING"
    ],
    "letterPool": [
      "R",
      "R",
      "R",
      "A",
      "N",
      "N",
      "N",
      "D",
      "E",
      "E",
      "S",
      "S",
      "K",
      "O",
      "L",
      "I",
      "G",
      "H"
    ],
    "poolString": "RRRANNNDEESSKOLIGH"
  },
  {
    "levelNumber": 100,
    "category": "Kalender",
    "correctAnswer": "SKUDÅR",
    "alternativeWords": [
      "JULI",
      "MÅNED",
      "MINUT"
    ],
    "letterPool": [
      "S",
      "K",
      "U",
      "D",
      "Å",
      "R",
      "R",
      "J",
      "L",
      "I",
      "M",
      "N",
      "N",
      "E",
      "E",
      "T",
      "T",
      "A"
    ],
    "poolString": "SKUDÅRRJLIMNNEETTA"
  }
];

/**
 * Get level data for a specific language
 * @param {string} language - Language code ('en' or 'da')
 * @returns {Array} Array of level objects
 */
export function getLevelData(language = 'en') {
  const data = language === 'da' ? levelDataDA : levelDataEN;
  
  if (!data || data.length === 0) {
    console.error(`No level data found for language: ${language}`);
    return [];
  }
  
  return data;
}

/**
 * Get a specific level by number
 * @param {number} levelNumber - Level number (1-100)
 * @param {string} language - Language code ('en' or 'da')
 * @returns {Object|null} Level object or null if not found
 */
export function getLevel(levelNumber, language = 'en') {
  const data = getLevelData(language);
  return data.find(level => level.levelNumber === levelNumber) || null;
}

/**
 * Get total number of levels for a language
 * @param {string} language - Language code ('en' or 'da')
 * @returns {number} Total number of levels
 */
export function getTotalLevels(language = 'en') {
  return getLevelData(language).length;
}

/**
 * Get all categories for a language
 * @param {string} language - Language code ('en' or 'da')
 * @returns {Array<string>} Array of unique category names
 */
export function getCategories(language = 'en') {
  const data = getLevelData(language);
  return [...new Set(data.map(level => level.category))];
}

/**
 * Get levels by category
 * @param {string} category - Category name
 * @param {string} language - Language code ('en' or 'da')
 * @returns {Array} Array of level objects in the category
 */
export function getLevelsByCategory(category, language = 'en') {
  const data = getLevelData(language);
  return data.filter(level => level.category === category);
}

/**
 * Get difficulty tier information for a level
 * @param {number} levelNumber - Level number (1-100)
 * @returns {Object} Difficulty tier information
 */
export function getDifficultyTier(levelNumber) {
  return {
    min: 1,
    max: 100,
    camouflageRatio: 0.5  // 50% distracting letters
  };
}

// Default export
const levelDataExports = {
  getLevelData,
  getLevel,
  getTotalLevels,
  getCategories,
  getLevelsByCategory,
  getDifficultyTier
};

export default levelDataExports;
